// src/components/UI.js
import React, {
    createContext,
    forwardRef,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import styled, { keyframes } from "styled-components";
import { Row, Col } from "./RowCol";
import { Popover, PopoverTrigger, PopoverContent } from "./popover";
import { Button } from "./button";
import {
    FormProvider,
    useFormContext,
    useForm as useReactHookForm,
    Controller,
    useFieldArray,
} from "react-hook-form";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./select";
import { createRoot } from "react-dom/client";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
} from "./command";
import { Check, ChevronsUpDown, ChevronUp, ChevronDown, Terminal, Pencil, Edit } from "lucide-react";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator,
} from "./breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { RadioGroup, RadioGroupItem } from "./radio-group";
import { Label } from "./label";
import { Loader2 } from "lucide-react";
import {
    ResponsiveModal,
    ResponsiveModalContent,
    ResponsiveModalDescription,
    ResponsiveModalHeader,
    ResponsiveModalTitle,
} from "./responsive-modal";
import { Calendar } from "./calendar";
import { cn } from "./utils";
import { CalendarIcon } from "lucide-react";
import dayjs from "dayjs";
import isMoment from 'dayjs/plugin/isMoment';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "./card";
import { useDropzone } from "react-dropzone";
import "@xyflow/react/dist/style.css";
import {
    ReactFlow,
    addEdge,
    ConnectionLineType,
    Panel,
    useNodesState,
    useEdgesState,
} from "@xyflow/react";
import dagre from "dagre";
import "@xyflow/react/dist/style.css";
import { useCallback } from "react";
import { Input } from "./input";
import { useTranslation } from "react-i18next";
import { Badge } from "./badge";
import { Toaster, toast } from "sonner";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import AsyncSelect from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable';
import ReactSelect from 'react-select';
import { CustomSwitchWithMore } from "./custom_switch";
import * as d3 from "d3";
import { Checkbox } from "./checkbox";
import { cloneElement } from "react";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "./carousel";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "./dropdown-menu";
import { CheckIcon, ChevronDownIcon } from '@radix-ui/react-icons';
import { HexColorPicker, RgbColorPicker } from "react-colorful";
import MultipleSelector from "./multiple-selector";
import UploadImg from "./upload_img";
import UploadAudio from "./upload_audio";
import UploadDocument from "./upload_document";
import { Textarea } from "./textarea";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './accordion'
import ClassifyStructure from './classify_structure/Main'
import { DateTimePicker, TimePickerInput, TimePicker, TimePickerForForm } from './date_time_picker'
import { AspectRatio } from "./aspect-ratio"
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './tooltip'
import Divider from './divider'
// import { DateTimePicker } from './datetime-picker'
import { Skeleton } from './skeleton'
import { ChartOverview, ColumnChart, BarGraghChart, StackedColumnChart, GroupColumnChart, LineBasicChart, PieBasicChart, DonutChart, RadarBasicChart } from '../charts/views/chart_overview'
import JoditEditor from "jodit-react";
import TabsCard from './tabsCard';
import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from './resizable'
dayjs.extend(isMoment);

export { DateTimePicker, TimePickerInput, TimePicker, TimePickerForForm }
export {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "./dropdown-menu";

export { Row, Col } from "./RowCol";
export { Popover, PopoverTrigger, PopoverContent } from "./popover";
export { toast } from "sonner";
export { default as ProTableOt } from "./../utility/componentOt/views/ProtableOt";
export { default as ImportButton } from "./../utility/componentOt/views/ImportButton";
export { useProTableOt } from "./../utility/componentOt/controllers/ProtableOtController";
export { Textarea } from "./textarea";
export { Popconfirm } from "./popconfirm";
export { default as Mainlayout } from "./mainlayout";
export { Label };
export { Calendar }

export { Badge };
export { TabsCard };
export { UploadImg };
export { UploadAudio };
export { UploadDocument };
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
export { AspectRatio }
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
export { Divider }
export { ChartOverview, ColumnChart, BarGraghChart, StackedColumnChart, GroupColumnChart, LineBasicChart, PieBasicChart, DonutChart, RadarBasicChart }
export { useCRUDController } from "./classify_structure/CRUDController";
export { ResizablePanelGroup, ResizablePanel, ResizableHandle }

const StyledCol = styled.div`
    padding-left: ${(props) => props.gutter / 2}px;
    padding-right: ${(props) => props.gutter / 2}px;
    flex: 0 0 ${(props) => (props.span / 24) * 100}%;
    max-width: ${(props) => (props.span / 24) * 100}%;
`;
const DeletePopHover = ({ onConfirm = () => { }, onCancel = () => { } }) => {
    const [deleteOpen, setDeleteOpen] = useState(false);

    return (
        <Popover open={deleteOpen}>
            <PopoverTrigger asChild>
                <Button
                    onClick={() => {
                        setDeleteOpen(true);
                    }}
                    style={{
                        backgroundColor: '#FFCDD2',
                        color: '#D32F2F'
                    }}
                >
                    刪除
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-60">
                <Row>
                    <Col span={24}>確定要刪除嗎？</Col>
                    <Col span={24}>
                        <Row justify={"space-around"}>
                            <Col>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => {
                                        setDeleteOpen(false);
                                        onCancel();
                                    }}
                                >
                                    取消
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    size="sm"
                                    onClick={() => {
                                        onConfirm();
                                    }}
                                >
                                    確定
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </PopoverContent>
        </Popover>
    );
};

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce(
        (all, [key, value]) =>
            value === "" ? { ...all } : { ...all, [key]: value },
        {}
    );
};

const P = ({ children = <></>, mt = 3, leading = 7, style = {}, ...props }) => {
    return (
        <>
            <p
                className={
                    "leading-" + leading + " [&:not(:first-child)]:mt-" + mt
                }
                style={{ ...style }}
                {...props}
            >
                {children}
            </p>
        </>
    );
};
const Title = ({ level = 1, ...props }) => {
    if (level === 2) {
        return (
            <h2
                className="scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight first:mt-0"
                {...props}
            ></h2>
        );
    } else if (level === 3) {
        return (
            <h3
                className="scroll-m-20 text-2xl font-semibold tracking-tight"
                {...props}
            ></h3>
        );
    } else if (level === 4) {
        return (
            <h4
                className="scroll-m-20 text-xl font-semibold tracking-tight"
                {...props}
            ></h4>
        );
    } else {
        return (
            <h1
                className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl"
                {...props}
            ></h1>
        );
    }
};
const Typography = () => { };
Typography.P = P;
Typography.Title = Title;


const convertUndefined = (value) => {
    if (typeof value === 'object' && value !== null) {
        // If the value is an object or array, recursively handle its properties or elements
        Object.keys(value).forEach((key) => {
            if (value instanceof File) {
            } else {
                value[key] = convertUndefined(value[key]);
            }
        });
    } else if (value === 'undefined') {
        // If the value is the string 'undefined', convert it to actual undefined
        return undefined;
    }
    return value;
}
const CustomForm = ({
    form,
    initialValues,
    onValuesChange = () => { },
    onFinish,
    children,
    labelCol = 8,
    wrapperCol = 16,
    ...rest
}) => {
    const form_ = useReactHookForm();
    const reactHookForm = form || form_;
    const onSubmit = async (data, ...props) => {
        if (onFinish) {
            await onFinish(data);
        }
    };
    const convertUndefined = (value) => {
        if (typeof value === 'object' && value !== null && !(value instanceof File)) {
            // If the value is an object or array, recursively handle its properties or elements
            Object.keys(value).forEach((key) => {
                value[key] = convertUndefined(value[key]);
            });
        } else if (value === 'undefined') {
            // If the value is the string 'undefined', convert it to actual undefined
            return undefined;
        }
        return value;
    }
    useEffect(() => {
        const subscription = reactHookForm.watch((value, { name, type }) => {
            if (type) {
                const values = convertUndefined(value);
                return onValuesChange(values, { name, type })
            }
        });
        return () => subscription.unsubscribe();
    }, [reactHookForm.watch]);

    useEffect(() => {
        if (initialValues) reactHookForm.reset(initialValues);
    }, []);

    reactHookForm.submit = () => {
        reactHookForm.handleSubmit(onSubmit)();
    };

    return (
        <FormProvider {...reactHookForm}>
            <form onSubmit={reactHookForm?.handleSubmit(onSubmit)} {...rest}>
                {children}
            </form>
        </FormProvider>
    );
};
const CustomFormItem = ({
    name,
    label,
    children = <div></div>,
    rules = [],
    hidden = false,
    labelCol = 8,
    labelStyle = {},
    wrapperCol = 16,
    extra,
}) => {
    const {
        register,
        formState: { errors, isSubmitted },
        control,
    } = useFormContext();
    const filteredName = Array.isArray(name)
        ? name.filter(item => item !== "" && item !== undefined && item !== null)
        : [name];
    const internalName = Array.isArray(filteredName) ? filteredName.join(".") : filteredName;
    const valueCol = label ? wrapperCol : 24
    const nameHasError = !!errors[internalName];
    return (
        <>
            <Controller
                name={internalName}
                control={control}
                rules={rules?.find((_) => true)}
                render={({
                    field: { onChange: onFieldChange, value, id },
                    formState: { errors, isSubmitted },
                }) => (
                    <div style={{ marginBottom: "16px" }} hidden={hidden}>
                        <Row className="mb-2" gutter={[8, 4]} align={"middle"}>
                            {label && (
                                <>
                                    <Col className="text-right" span={labelCol} style={{ ...labelStyle }}>
                                        {rules.find(rule => rule?.required) && <sup style={{ color: 'red' }} >*</sup>}
                                        <label>{label}：</label>
                                    </Col>
                                </>
                            )}
                            <Col
                                span={
                                    isSubmitted && nameHasError && rules.length !== 0
                                        ? valueCol - 4
                                        : valueCol
                                }
                            >
                                <Row>
                                    <Col span={24}>
                                        {React.cloneElement(children, {
                                            key: id,
                                            name: internalName,
                                            onValueChange: (e) => {
                                                onFieldChange(e);
                                                if (
                                                    children?.props?.hasOwnProperty(
                                                        "onChange"
                                                    )
                                                )
                                                    children?.props?.onChange(e);
                                            },
                                            value: value !== undefined ? value : "",
                                            ...register(internalName),
                                        })}
                                    </Col>

                                </Row>
                            </Col>
                            <Col span={24}>
                                <div style={{
                                    color: "#999899",
                                    fontSize: "12px"
                                }}>
                                    <Row justify={"end"}>
                                        <Col span={valueCol}>
                                            {typeof extra === "string" ? <Typography.P> {extra}</Typography.P> : extra}

                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            {isSubmitted && nameHasError && rules.map(
                                (rule) =>
                                    rule?.required && (
                                        <Col className="text-red-600 italic">
                                            {rule?.message}
                                        </Col>
                                    )
                            )}
                        </Row>
                        {errors[name] && (
                            <span style={{ color: "red" }}>
                                {errors[name].message}
                            </span>
                        )}
                    </div>
                )}
            />
        </>
    );
};
const CustomFormList = ({ label, name, children,
    labelCol = 0,
    wrapperCol = 24, }) => {
    const { control } = useFormContext();
    const filteredName = Array.isArray(name)
        ? name.filter(item => item !== "" && item !== undefined && item !== null)
        : [name];
    const internalName = filteredName.join(".");
    const { fields, append, remove, move } = useFieldArray({
        control,
        name: internalName,
    });
    return (
        <div>
            <Row className="mb-2" gutter={[8, 16]} align={"middle"}>
                {label && (
                    <>
                        <Col className="text-right" span={labelCol}>
                            <Typography.Title level={4}>{label}</Typography.Title>
                        </Col>
                    </>
                )}
                <Col
                    span={wrapperCol}
                >
                </Col>
            </Row>
            <Row className="mb-2" gutter={[8, 16]} align={"middle"}>
                <Col className="text-right" span={labelCol}>
                </Col>
                <Col
                    span={wrapperCol}
                >
                    {
                        children(
                            fields.map((mapItem, index) => ({
                                ...mapItem,
                                name: [internalName, index].join("."),
                            })),
                            { add: (item = {}) => append(item), remove, move }
                        )
                    }
                </Col>
            </Row>
        </div >
    );
};
const useForm = (options) => {
    const methods = useReactHookForm(options);

    const setFieldsValue = (values, name = undefined) => {
        if (values === null) {
            values = {};
        }
        Object.keys(values).forEach((field) => {
            const fields = name ? [name, field] : [field];
            methods.setValue(fields.join("."), values[field]);
            if (typeof values[field] === "object")
                setFieldsValue(values[field], fields.join("."));
        });
    };

    const setFieldValue = (name, value) => {
        setFieldsValue({ [name]: value })
    };
    const resetFields = (values) => {
        methods.reset();
    };
    const getFieldValue = (values) => {
        const internalName = Array.isArray(values) ? values.join(".") : values;
        return methods.getValues(internalName);
    };
    const getFieldsValue = () => {
        return methods.getValues();
    };
    methods.getFieldValue = getFieldValue;
    methods.getFieldsValue = getFieldsValue;
    methods.setFieldsValue = setFieldsValue;
    methods.setFieldValue = setFieldValue;
    methods.resetFields = resetFields;
    return [methods];
};

const useWatch = (name, form) => {
    const internalName = Array.isArray(name) ? name.join(".") : name;
    const form_ = useReactHookForm();
    const reactHookForm = form || form_;
    const values = reactHookForm.watch(internalName);
    return convertUndefined(values);
};
CustomForm.Item = CustomFormItem;
CustomForm.List = CustomFormList;
CustomForm.useForm = useForm;
CustomForm.useWatch = useWatch;

export { CustomForm as Form, useFormContext };


const CustomSelect = ({ value = undefined, onValueChange = () => { }, onChange = () => { }, defaultValue, placeholder, options = [], name, defaulDisabled = false, ...props }) => {
    const extendedOptions = [{ label: '請選擇 ...', value: undefined, disabled: defaulDisabled }, ...options];
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    return <>
        <>
            {
                control ?
                    <Controller
                        name={name}
                        control={control}
                        render={
                            ({ field, fieldState: { error } }) => (
                                <Select
                                    name={field.name}
                                    onValueChange={
                                        (e) => {
                                            onValueChange(e);
                                            field.onChange({
                                                target: {
                                                    name,
                                                    value: e
                                                }
                                            })
                                            onChange({
                                                target: {
                                                    name,
                                                    value: e
                                                }
                                            })
                                        }
                                    } value={value !== undefined ? `${value}` : ''}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={value !== undefined ? undefined : placeholder || "請選擇 ..."} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {
                                            extendedOptions.map(mapItem => <>
                                                <SelectItem {...mapItem} value={`${mapItem?.value}`}> {mapItem?.label || mapItem?.value}</SelectItem>
                                            </>)}
                                    </SelectContent>
                                </Select>
                            )}
                    />
                    :
                    <Select
                        name={name}
                        onValueChange={(e) => {
                            onValueChange(e);
                            onChange(e)
                        }} value={value !== undefined ? `${value}` : undefined}
                    >
                        <SelectTrigger>
                            <SelectValue placeholder={value !== undefined ? undefined : placeholder || "請選擇 ..."} />
                        </SelectTrigger>
                        <SelectContent>
                            {
                                extendedOptions.map(mapItem => <>
                                    <SelectItem {...mapItem} value={`${mapItem?.value}`}> {mapItem?.label || mapItem?.value}</SelectItem>
                                </>)}
                        </SelectContent>
                    </Select>
            }
        </>
    </>
}

const CustomAsyncSelect = ({
    request
    // = async () => {
    //     return await new Promise(
    //         (resolve, reject) => {
    //             resolve()
    //         }
    //     )
    //         .then(() => {
    //             return {
    //                 data: Array(1000).fill(0).map((item, index) => ({ label: index, value: index })),
    //                 total: 0
    //             }
    //         })
    // }
    ,
    defaultValue,
    placeholder = '請選擇 ...',
    defaulDisabled = false,
    value = undefined,
    name = undefined,
    onChange = () => { },
    onSelect = () => { },
    onValueChange = () => { },
    options,
    mode: mode_,
    allowClear = false,
    disabled = false,
    onlyValue = true,
    onlyValueAll = false,
    ...props
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [internalOptions, setInternalOptions] = useState([])
    const externalOptions = options || internalOptions

    const loadMoreOptions = async (...args) => {
        if (request) {
            setIsLoading(true);
            const result = await request()
            setInternalOptions(result)
            setIsLoading(false);
            return result?.data;
        }
        return options
    };
    const mode = ['multiple', 'tags'].includes(mode_) ? 'multiple' : undefined
    const ReactSelect_ = mode_ === "tags" ? CreatableSelect : ReactSelect
    return <>
        {request && <>
            <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={loadMoreOptions}
                onMenuScrollToBottom={loadMoreOptions}
                isLoading={isLoading}
                isDisabled={disabled}
                {...(value ? {
                    value: Array.isArray(value) ?
                        externalOptions.filter(item => value.includes(item.value))?.map(item => item)
                        :
                        externalOptions.find(item => String(item.value) === String(value))
                } : {}
                )}
                {...(onlyValue ? {} : { value: value })}
                onChange={(e) => {
                    let values = e
                    if (mode === "multiple") {
                        if (onlyValue) {
                            values = e?.map(item => item.value)
                        } else {
                            values = e
                        }
                    }
                    if (name) {
                        onChange({
                            target: {
                                name,
                                value: values
                            }
                        })
                        onValueChange({
                            target: {
                                name,
                                value: values
                            }
                        })
                    } else {
                        onChange(values)
                        onValueChange(values)
                    }
                }}
            />
        </>}
        {!request && <>
            <ReactSelect_
                placeholder={placeholder}
                defaultValue={defaultValue}
                isClearable={allowClear}
                isDisabled={disabled}
                styles={{
                    menu: (provided) => ({
                        ...provided,
                        width: 'auto', // Allows the width to be determined by the content
                        minWidth: '100%', // Ensures that the dropdown is at least as wide as the select input
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        width: 'auto', // Adjusts the list width according to content
                    }),
                    container: (provided) => ({
                        ...provided,
                        width: 'auto', // Optional: Adjust the container width if needed
                    }),
                }}
                {...(value ? {
                    value: Array.isArray(value) ?
                        externalOptions.filter(item => value.includes(item.value))?.map(item => item)
                        :
                        externalOptions.find(item => String(item.value) === String(value))
                } : {}
                )}
                {...(onlyValue ? {} : { value: value })}
                isMulti={mode === "multiple"}
                closeMenuOnSelect={mode !== "multiple"}
                options={externalOptions}
                onChange={(e) => {
                    let values = e?.value
                    if (mode === "multiple") {
                        if (onlyValue) {
                            values = e?.map(item => item.value)
                        } else {
                            if (onlyValueAll) {
                                values = e
                            } else {
                                values = e?.value
                            }
                        }
                    }
                    if (name) {
                        onChange({
                            target: {
                                name,
                                value: values
                            }
                        })
                        onValueChange({
                            target: {
                                name,
                                value: values
                            }
                        })
                        onSelect(values)
                    } else {
                        onChange(values)
                        onValueChange(values)
                        onSelect(values)
                    }
                }}
            />
        </>}
    </>
};

const CustomMultipleSelect = ({ value = undefined, onValueChange = () => { }, onChange = () => { }, defaultValue, placeholder, options = [], name, defaulDisabled = false, ...props }) => {
    const extendedOptions = [{ label: '請選擇 ...', value: undefined, disabled: defaulDisabled }, ...options];
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const label_string = Array.isArray(value) && value.length > 0 ?
        value?.map((mapItem) => (
            extendedOptions.find((option) => `${option?.value}` == `${mapItem}`)?.label || ''
        )).join(',') :
        ''

    const renderSelectComponent = (field = null, name) => (
        <Select
            onValueChange={(selectedValue) => {
                const newSelectedValues = value.includes(selectedValue)
                    ? value.filter(v => v !== selectedValue)
                    : [...value, selectedValue];
                onValueChange(newSelectedValues);
                field.onChange({
                    target: {
                        name,
                        value: newSelectedValues
                    }
                })
                onChange({
                    target: {
                        name,
                        value: newSelectedValues
                    }
                })
            }}
        >
            <SelectTrigger>
                <SelectValue placeholder={label_string != '' ? label_string : placeholder}>
                    {label_string != '' ? label_string : ''}
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                {
                    extendedOptions.map(mapItem => (
                        <SelectItem
                            {...mapItem}
                            value={`${mapItem?.value}`}
                        >
                            <Row>
                                {mapItem?.label || mapItem?.value}
                                {
                                    value && value.includes(`${mapItem?.value}`) && (
                                        <CheckIcon className="ml-2 text-green-500" />
                                    )
                                }
                            </Row>
                        </SelectItem>
                    ))}
            </SelectContent>
        </Select >
    );
    return <>
        <>
            {
                control ?
                    <Controller
                        name={name}
                        control={control}
                        render={({ field, fieldState: { error } }) => renderSelectComponent(field, name)}
                    />
                    :
                    renderSelectComponent()
            }
        </>
    </>
}

export { SelectContent, SelectItem, SelectTrigger, SelectValue, }
CustomAsyncSelect.MultipleSelect = CustomMultipleSelect
export { CustomAsyncSelect as Select };

const CustomSelectCombo = ({
    name,
    rules,
    onValueChange,
    defaultValue,
    placeholder,
    options = [],
    ...props
}) => {
    const { control } = useFormContext();
    return (
        <>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                }) => (
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button
                                variant="outline"
                                role="combobox"
                                className={
                                    // cn(
                                    "w-[200px] justify-between"
                                    // !field.value && "text-muted-foreground"
                                    // )
                                }
                            >
                                {value
                                    ? options.find(
                                        (option) => option.value === value
                                    )?.label
                                    : "Select option"}
                                <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent className="w-[200px] p-0">
                            <Command>
                                <CommandInput placeholder="Search option..." />
                                <CommandEmpty>No option found.</CommandEmpty>
                                <CommandGroup>
                                    {options.map((option) => (
                                        <CommandItem
                                            value={option.label}
                                            key={option.value}
                                            onSelect={() => {
                                                onChange(option.value);
                                            }}
                                        >
                                            <Check className={"opacity-0"} />
                                            {option.label}
                                        </CommandItem>
                                    ))}
                                </CommandGroup>
                            </Command>
                        </DropdownMenuContent>
                    </DropdownMenu>
                )}
            />
        </>
    );
};
export { CustomSelectCombo as SelectCombo };

const CustomButton = ({
    type = "primary", // 按鈕類型
    loading = false, // 是否顯示 loading 狀態
    size = "medium", // 按鈕大小
    htmlType = "button", // HTML 按鈕類型
    block = false, // 是否全寬
    selected = false, // 是否處於選中狀態
    ...props // 其餘 props
}) => {
    const sizeStyles = {
        small: "sm",
        medium: "default",
        large: "lg",
        icon: "icon",
    };
    const sizeStyle = sizeStyles[size] || sizeStyles.medium;

    const typeMapping = {
        text: "link",
        link: "link",
        danger: "destructive",
        default: "outline",
    };

    const variant = typeMapping[type];

    const selectedStyle = selected
        ? {
            border: "2px solid #5c9ded", // 調整為柔和藍色
            backgroundColor: "#edf5ff", // 輕微淺藍背景
            color: "#2b65d3", // 藍色文字，和諧且不突兀
            fontWeight: "bold", // 突出文字
        }
        : {};

    return (
        <>
            {!loading && (
                <Button
                    type={htmlType}
                    variant={variant}
                    size={sizeStyle}
                    style={{
                        ...props.style,
                        ...selectedStyle, // 添加選中樣式
                        width: block ? "100%" : "auto",
                    }}
                    {...props}
                >
                    {props.children}
                </Button>
            )}
            {loading && (
                <Button
                    disabled
                    type={htmlType}
                    variant={variant}
                    size={sizeStyle}
                    style={{
                        ...props.style,
                        ...selectedStyle, // 添加選中樣式
                        width: block ? "100%" : "auto",
                    }}
                    {...props}
                >
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    {props?.children}
                </Button>
            )}
        </>
    );
};
const CustomButtonRadioGroup = ({
    options = [],
    name,
    value,
    onChange,
    onValueChange,
    buttonType = "primary", // 默認按鈕類型
    buttonSize = "medium", // 默認按鈕大小
}) => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleClick = (optionValue) => {
        setSelectedValue(optionValue);

        // 模擬原生事件結構，讓父層更好處理
        const event = {
            target: {
                name,
                value: optionValue,
            },
        };

        if (onChange) {
            onChange(event);
        }

        if (onValueChange) {
            onValueChange(optionValue);
        }
    };

    return (
        <div style={{ display: "flex", gap: "8px" }}>
            {options.map((option, index) => (
                <CustomButton
                    key={index}
                    type={buttonType}
                    size={buttonSize}
                    selected={selectedValue === option.value} // 使用選中樣式
                    onClick={() => handleClick(option.value)}
                >
                    {option.label}
                </CustomButton>
            ))}
        </div>
    );
};
CustomButton.RadioGroup = CustomButtonRadioGroup


export { CustomButton as Button };

const CustomBreadCrumb = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);
    const { t } = useTranslation();
    return (
        <Breadcrumb>
            {console.log({ t })}
            <BreadcrumbList>
                <BreadcrumbItem>
                    <BreadcrumbLink onClick={() => navigate("/")}>
                        <HomeOutlined />
                    </BreadcrumbLink>
                </BreadcrumbItem>
                {pathnames.map((value, index) => {
                    const to = `/${pathnames
                        .slice(0, index + 1)
                        .join("/")}`;
                    return (
                        <React.Fragment key={to}>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbLink
                                    onClick={() => navigate(to)}
                                >
                                    {t(
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") + "."
                                    ) !==
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") &&
                                        t(
                                            pathnames
                                                .slice(0, index + 1)
                                                .join(".") + "."
                                        )}
                                    {t(
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") + "."
                                    ) ===
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") &&
                                        value.charAt(0).toUpperCase() +
                                        value.slice(1)}
                                </BreadcrumbLink>
                            </BreadcrumbItem>
                        </React.Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
};
export { CustomBreadCrumb as BreadCrumb };

const CustomRadio = ({ children, value, ...props }) => {
    return (
        <>
            <Label style={{}}>
                <div className="flex items-center space-x-2">
                    <RadioGroupItem {...props} value={value} />
                    <Label>{children}</Label>
                </div>
            </Label>
        </>
    );
};
const CustomRadioGroup = ({
    name,
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    children,
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    return (
        <>
            <RadioGroup
                onValueChange={(e) => {
                    if (control) {
                        onValueChange({
                            target: {
                                name,
                                value: e,
                            },
                        });
                        onChange({
                            target: {
                                name,
                                value: e,
                            },
                        });
                    } else {
                        onValueChange(e);
                        onChange(e);
                    }
                }}
                className={props.className !== undefined ? props.className : "flex flex-row"}
                value={value !== undefined ? value : ""}
            >
                {children}
            </RadioGroup>
        </>
    );
};
CustomRadio.Group = CustomRadioGroup;
export { CustomRadio as Radio };

const CustomModal = ({
    title,
    children,
    open,
    footer,
    onCancel,
    onOk,
    onClose,
    okText = "OK",
    okProps = {},
    cancelText = "Cancel",
    closeText = "Close",
    modalRender,
    close = false,
    contentStyle = { padding: 0 },
    width,
    ...props
}) => {

    const modalContent = modalRender ? (
        modalRender({
            title,
            children,
            footer,
            onCancel,
            onOk,
            okText,
            okProps,
            cancelText,
        })
    ) : (
        <>
            <ResponsiveModalHeader>
                <ResponsiveModalTitle>{title}</ResponsiveModalTitle>
            </ResponsiveModalHeader>
            <ResponsiveModalDescription
                style={{
                    maxHeight: "80vh",
                    overflowX: "scroll",
                    overflowY: "scroll",
                    ...contentStyle
                }}
            >
                {children}
            </ResponsiveModalDescription>
            <div
                className={
                    "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2"
                }
            >
                {footer ? (
                    footer
                ) : (
                    <>
                        {onOk && <Button onClick={onOk} {...okProps}>
                            {okText}
                        </Button>}
                        {onCancel && <Button onClick={onCancel} variant="outline">
                            {cancelText}
                        </Button>}
                        {close && <Button onClick={onClose} variant="secondary">
                            {closeText}
                        </Button>}
                    </>
                )}
            </div>
        </>
    );
    return (
        <ResponsiveModal open={open} {...props}>
            <ResponsiveModalContent
                style={{
                    ...(width ? { width: width, maxWidth: "100vw" } : {}),
                    overflowY: 'hidden'
                }}
                close={close}
            >
                {modalContent}
            </ResponsiveModalContent>
        </ResponsiveModal>
    );
};
const info = ({
    title,
    footer,
    content,
    onOk,
    onCancel,
    okText = 'OK',
    cancelText = 'Cancel',
    ...props
}) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container)

    const handleOk = () => {
        if (onOk) onOk();
        closeModal();
    };
    const closeModal = () => {
        root.unmount()
        document.body.removeChild(container);
    };

    root.render(
        <CustomModal
            open={true}
            title={title}
            onOk={handleOk}
            okText={okText}
            contentStyle={{ padding: 8 }}
            {...props}
        >
            {content}
        </CustomModal>
    );
};

const confirm = ({
    title,
    content,
    onOk,
    onCancel,
    onClose,
    okText = "OK",
    cancelText = "Cancel",
    ...props
}) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = createRoot(container);
    const handleOk = () => {
        if (onOk) onOk();
        closeModal();
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
        closeModal();
    };
    const handleClose = () => {
        if (onClose) onClose();
        closeModal();
    };

    const closeModal = () => {
        root.unmount();
        document.body.removeChild(container);
    };

    root.render(
        <CustomModal
            open={true}
            title={title}
            onOk={handleOk}
            onCancel={handleCancel}
            onClose={handleClose}
            okText={okText}
            cancelText={cancelText}
            contentStyle={{ padding: 8 }}
            {...props}
        >
            {content}
        </CustomModal>
    );
};
CustomModal.confirm = confirm;
CustomModal.info = info
export { CustomModal as Modal };

const Alert = styled.div`
    & .alert {
        padding: 15px;
        margin-bottom: 20px;
        border: 1px solid transparent;
        border-radius: 4px;
        display: flex;
        align-items: center;
    }

    & .alert-success {
        color: #3c763d;
        background-color: #dff0d8;
        border-color: #d6e9c6;
    }

    & .alert-info {
        color: #31708f;
        background-color: #d9edf7;
        border-color: #bce8f1;
    }

    & .alert-warning {
        color: #8a6d3b;
        background-color: #fcf8e3;
        border-color: #faebcc;
    }

    & .alert-danger {
        color: #a94442;
        background-color: #f2dede;
        border-color: #ebccd1;
    }

    & .alert-icon {
        margin-right: 10px;
    }

    & .alert-content {
        display: flex;
        flex-direction: column;
    }

    & .alert-message {
        font-weight: bold;
    }

    & .alert-description {
        margin-top: 5px;
    }
`;
const CustomAlert = ({ type, message, description, icon, showIcon }) => {
    const renderIcon = () => {
        if (icon) {
            return React.cloneElement(icon, { className: "h-4 w-4" });
        }
        // Default to Terminal icon if no icon is provided
        return <Terminal className="h-4 w-4" />;
    };

    const alertType = () => {
        switch (type) {
            case "success":
                return "alert-success";
            case "info":
                return "alert-info";
            case "warning":
                return "alert-warning";
            case "error":
                return "alert-danger";
            default:
                return "alert-info";
        }
    };

    return (
        <Alert>
            <div
                className={`alert ${alertType()} ${showIcon ? "show-icon" : ""
                    }`}
                role="alert"
            >
                {showIcon && <span className="alert-icon">{renderIcon()}</span>}
                <div className="alert-content">
                    {message && <div className="alert-message">{message}</div>}
                    {description && (
                        <div className="alert-description">{description}</div>
                    )}
                </div>
            </div>
        </Alert>
    );
};
export { CustomAlert as Alert };

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
// 定義覆蓋層的樣式
const OverlayWrapper = styled.div`
    position: relative; /* 確保覆蓋層相對定位於此容器 */
`;
const LoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ hasChildren }) =>
        hasChildren
            ? "rgba(0, 0, 0, 0.5)"
            : "transparent"}; /* 半透明背景，若無 children 則為透明 */
    position: ${({ hasChildren }) =>
        hasChildren ? "absolute" : "static"}; /* 若有 children 則為覆蓋 */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: ${({ hasChildren, size }) =>
        !hasChildren ? `${size}px` : "auto"}; /* 無 children 則固定大小 */
    height: ${({ hasChildren, size }) => (!hasChildren ? `${size}px` : "auto")};
    z-index: 10;

    svg {
        animation: ${spin} 1s linear infinite;
        width: ${({ size }) => (size ? `${size}px` : "24px")};
        height: ${({ size }) => (size ? `${size}px` : "24px")};
    }
`;

const Spin = ({ size = 24, spinning = true, children }) => {
    const hasChildren = React.Children.count(children) > 0;
    return (
        <OverlayWrapper>
            {spinning && (
                <LoaderWrapper size={size} hasChildren={hasChildren}>
                    <Loader2 />
                </LoaderWrapper>
            )}
            {hasChildren && children}
        </OverlayWrapper>
    );
};
export { Spin };
export { DeletePopHover, setParamsFilter, Typography };

const CustomDatePicker = ({
    name = "",
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    options,
    format = "YYYY-MM-DD",
    timeZone = "Asia/Taipei",  // 設定預設時區
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [open, setOpen] = useState(false);
    const popoverRef = useRef(null);

    const handleFocusOut = (event) => {
        if (
            popoverRef.current &&
            !popoverRef.current.contains(event.relatedTarget)
        ) {
            setOpen(false);
        }
    };

    // // 使用 formatDateToTimeZone 函數來格式化日期
    // const formatDateToTimeZone = (date, locale = 'en-US', timeZone = timeZone) => {
    //     return new Intl.DateTimeFormat(locale, {
    //         timeZone,
    //         year: 'numeric',
    //         month: '2-digit',
    //         day: '2-digit',
    //     }).format(date);
    // };

    useEffect(() => {
        const currentPopoverRef = popoverRef.current;
        if (currentPopoverRef) {
            currentPopoverRef.addEventListener("focusout", handleFocusOut);
        }

        return () => {
            if (currentPopoverRef) {
                currentPopoverRef.removeEventListener(
                    "focusout",
                    handleFocusOut
                );
            }
        };
    }, []);
    return (
        <>
            <DropdownMenu open={open} ref={popoverRef}>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant={"outline"}
                        className={cn(
                            "w-[240px] pl-3 text-left font-normal",
                            !value && "text-muted-foreground"
                        )}
                        onClick={() => setOpen(true)}
                    >
                        {value ? (
                            formatDateToTimeZone(new Date(value), undefined, timeZone)
                        ) : (
                            <span>Pick a date</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-auto p-0" align="start">
                    {control ? (
                        <Controller
                            name={name}
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <Calendar
                                    mode="single"
                                    selected={dayjs(value).format(format)}
                                    onSelect={(date, ...e) => {
                                        const selectedDate = formatDateToTimeZone(date, undefined, timeZone);
                                        onValueChange({
                                            target: {
                                                name,
                                                value: selectedDate,
                                            },
                                        });
                                        onChange({
                                            target: {
                                                name,
                                                value: selectedDate,
                                            },
                                        });
                                        setOpen(false);
                                    }}
                                    initialFocus
                                />
                            )}
                        />
                    ) : (
                        <Calendar
                            mode="single"
                            selected={value}
                            onSelect={(date, ...e) => {
                                const selectedDate = formatDateToTimeZone(date, undefined, timeZone);
                                onChange(
                                    date,
                                    selectedDate,
                                    ...e
                                );
                                onValueChange(
                                    date,
                                    selectedDate,
                                    ...e
                                );
                                setOpen(false);
                            }}
                            initialFocus
                        />
                    )}
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
};

const formatDateToTimeZone = (date, locale = 'en-US', timeZone = "Asia/Taipei") => {
    return new Intl.DateTimeFormat(locale, {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
};
export { formatDateToTimeZone }
const CustomDateTimePicker = ({
    name = "",
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    options,
    format = "YYYY-MM-DD HH:mm:ss",
    disabled,
    granularity = "second",
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [open, setOpen] = useState(false);
    const popoverRef = useRef(null);

    const handleFocusOut = (event) => {
        if (
            popoverRef.current &&
            !popoverRef.current.contains(event.relatedTarget)
        ) {
            setOpen(false);
        }
    };

    // 資料轉換 function: 將輸入轉換為 Day.js 格式
    const toDayjs = (date) => {
        if (!date) return dayjs(); // 如果 date 為空，返回當前時間的 Day.js 對象

        if (typeof date === 'string') {
            // 如果是字串格式，直接使用指定的格式進行解析
            return dayjs(date, format);
        } else if (date instanceof Date) {
            // 如果是 JavaScript Date 對象，直接轉換為 Day.js
            return dayjs(date);
        } else if (dayjs.isMoment(date)) {
            // 如果是 Moment 對象，將其轉換為 Day.js
            return dayjs(date.toDate());
        } else if (dayjs.isDayjs(date)) {
            // 如果已經是 Day.js 對象，直接返回
            return date;
        } else {
            console.warn("Unsupported date format, defaulting to current date");
            return dayjs(); // 如果資料格式不受支持，返回當前時間
        }
    };

    const dayjsValue = value ? toDayjs(value) : undefined;
    useEffect(() => {
        const currentPopoverRef = popoverRef.current;
        if (currentPopoverRef) {
            currentPopoverRef.addEventListener("focusout", handleFocusOut);
        }

        return () => {
            if (currentPopoverRef) {
                currentPopoverRef.removeEventListener(
                    "focusout",
                    handleFocusOut
                );
            }
        };
    }, []);
    return (
        <>

            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <DateTimePicker
                            // yearRange
                            hourCycle={24}
                            placeholder={placeholder || format}
                            disabled={disabled}
                            granularity={granularity}
                            value={dayjsValue ? dayjsValue.toDate() : undefined}
                            onChange={(date) => {
                                const formattedDate = dayjs(date).format(format);
                                onValueChange({
                                    target: {
                                        name,
                                        value: formattedDate
                                    },
                                });
                                onChange({
                                    target: {
                                        name,
                                        value: formattedDate
                                    },
                                });
                            }}
                        />
                    )}
                />
            ) : (
                <DateTimePicker
                    // yearRange
                    value={dayjsValue ? dayjsValue.toDate() : undefined}
                    hourCycle={24}
                    placeholder={placeholder || format}
                    disabled={disabled}
                    granularity={granularity}
                    onChange={(date) => {
                        const formattedDate = dayjs(date).format(format);
                        onValueChange({
                            target: {
                                name,
                                value: formattedDate
                            },
                        });
                        onChange({
                            target: {
                                name,
                                value: formattedDate
                            },
                            date: formattedDate,
                            dateString: formattedDate,
                        });
                    }}
                />
            )}

        </>
    );
}

CustomDatePicker.Time = CustomDateTimePicker
export { CustomDatePicker as DatePicker };
const CustomDateRangePicker = ({
    placeholder = ["開始日期", "結束日期"],
    name = "",
    value,
    defaultValue,
    onValueChange = () => { },
    onChange = () => { },
    format = "YYYY-MM-DD HH:mm:ss",
    disabled,
    ...props
}) => {

    const [search, setSearch] = useState({
        time_start: value?.[0] ?? defaultValue?.[0],
        time_end: value?.[1] ?? defaultValue?.[1],
    })
    useEffect(() => {
        if (!!search?.time_start && !!search?.time_end) {
            onValueChange({
                target: {
                    name,
                    value: [search?.time_start, search?.time_end],
                },
            });
            onChange({
                target: {
                    name,
                    value: [search?.time_start, search?.time_end],
                },
            });
        }
        else {
            onValueChange({
                target: {
                    name,
                    value: [],
                },
            });
            onChange({
                target: {
                    name,
                    value: [],
                },

            });
        }
    }, [search])
    return (
        <Row gutter={[4, 4]} align={"middle"}>
            <Col>
                <CustomDateTimePicker
                    placeholder={placeholder[0]}
                    format={format}
                    value={search?.time_start ? dayjs(search?.time_start) : (value ? value?.find(_ => true)?.[0] ?? undefined : undefined)}
                    onChange={(e) => {
                        setSearch((pre) => {
                            let valid_value = "";
                            if (typeof e.target.value === "string") {
                                valid_value = dayjs(e.target.value);
                            } else {
                                valid_value = e.target.value;
                            }
                            if ((valid_value).isBefore(pre?.time_end)) {
                                return {
                                    ...pre,
                                    time_start: dayjs(e.target.value).format(format),
                                }
                            }
                            else {
                                return {
                                    ...pre,
                                    time_start: dayjs(pre?.time_end).format(format),
                                    time_end: dayjs(e.target.value).format(format),
                                }
                            }
                        })
                    }}
                />
            </Col>
            <Col>
                <Typography.Title level={4}>
                    ~
                </Typography.Title>
            </Col>
            <Col>
                <CustomDateTimePicker
                    placeholder={placeholder[1]}
                    format={format}
                    value={search?.time_end ? dayjs(search?.time_end) : (value ? value?.find(_ => true)?.[1] ?? undefined : undefined)}
                    onChange={(e) => {
                        setSearch((pre) => {
                            let valid_value = "";
                            if (typeof e.target.value === "string") {
                                valid_value = dayjs(e.target.value);
                            } else {
                                valid_value = e.target.value;
                            }
                            if ((valid_value).isBefore(pre?.time_start)) {
                                return {
                                    ...pre,
                                    time_start: dayjs(e.target.value).format(format),
                                    time_end: dayjs(pre?.time_start).format(format),
                                }
                            }
                            else {
                                return {
                                    ...pre,
                                    time_end: dayjs(e.target.value).format(format),
                                }
                            }

                        })
                    }}
                />
            </Col>
            <Col>
                <CustomButton
                    type={"icon"}
                    onClick={() => {
                        setSearch((pre) => {
                            return {
                                time_start: undefined,
                                time_end: undefined
                            }
                        })
                    }}>
                    X
                </CustomButton>
            </Col>
        </Row>

    )
}
export { CustomDateRangePicker as RangePicker }
const CustomCard = ({
    actions,
    activeTabKey,
    bordered = true,
    cover,
    defaultActiveTabKey,
    extra,
    hoverable,
    loading,
    size = "default",
    tabBarExtraContent,
    tabList,
    tabProps,
    title,
    type,
    classNames,
    styles = {
        padding: 16,
    },
    onTabChange,
    children,
}) => {
    const [currentTabKey, setCurrentTabKey] = useState(defaultActiveTabKey);

    const handleTabChange = (key) => {
        setCurrentTabKey(key);
        if (onTabChange) {
            onTabChange(key);
        }
    };

    const renderTabs = () => {
        if (!tabList) return null;
        return (
            <div className="card-tabs">
                {tabList.map((tab) => (
                    <div
                        key={tab.key}
                        className={`card-tab ${tab.key === currentTabKey ? "active" : ""
                            }`}
                        onClick={() => handleTabChange(tab.key)}
                    >
                        {tab.tab}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <Card
            className={`${bordered ? "bordered" : ""} ${hoverable ? "hoverable" : ""
                } ${classNames || ""}`}
            style={styles}
        >
            {(title || extra) && (
                <CardHeader className={`${size} ${type}`}>
                    {title && <CardTitle>{title}</CardTitle>}
                    {extra && <div className="card-extra">{extra}</div>}
                </CardHeader>
            )}
            {cover && <div className="card-cover">{cover}</div>}
            {renderTabs()}
            <CardContent class={'p-0'}>
                {loading ? (
                    <div className="card-loading">Loading...</div>
                ) : (
                    children
                )}
            </CardContent>
            {actions && actions.length > 0 && (
                <CardFooter className="card-actions">
                    {actions.map((action, index) => (
                        <div key={index} className="card-action">
                            {action}
                        </div>
                    ))}
                </CardFooter>
            )}
        </Card>
    );
};
export { CustomCard as Card };

const HomeOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M22 22H2M2 11l8.126-6.5a3 3 0 013.748 0L22 11"
                ></path>
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M15.5 5.5v-2A.5.5 0 0116 3h2.5a.5.5 0 01.5.5v5"
                    opacity="0.5"
                ></path>
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M4 22V9.5M20 22V9.5"
                ></path>
                <path
                    stroke="#1C274C"
                    strokeWidth="1.5"
                    d="M15 22v-5c0-1.414 0-2.121-.44-2.56C14.122 14 13.415 14 12 14c-1.414 0-2.121 0-2.56.44C9 14.878 9 15.585 9 17v5M14 9.5a2 2 0 11-4 0 2 2 0 014 0z"
                    opacity="0.5"
                ></path>
            </svg>
        </>
    );
};
const AudioFilled = ({ ...props }) => {
    return <>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            version="1.1"
            viewBox="0 0 261.075 261.075"
            xmlSpace="preserve"
            {...props}
        >
            <g fill="#010002">
                <path d="M126.855 174.05h5.744c22.447 0 40.641-18.194 40.641-40.641V40.641C173.24 18.194 155.046 0 132.599 0h-5.744c-22.447 0-40.641 18.194-40.641 40.641v92.769c.001 22.446 18.194 40.64 40.641 40.64z"></path>
                <path d="M124.288 201.147v43.61H86.215c-4.504 0-8.159 3.65-8.159 8.159s3.655 8.159 8.159 8.159h92.464c4.504 0 8.159-3.65 8.159-8.159s-3.655-8.159-8.159-8.159h-38.073v-43.823c34.832-3.138 63.262-34.44 63.262-71.208 0-4.509-3.655-8.159-8.159-8.159s-8.159 3.65-8.159 8.159c0 29.92-24.122 55.201-52.672 55.201h-8.686c-28.544 0-52.666-24.699-52.666-53.939 0-4.509-3.655-8.159-8.159-8.159s-8.159 3.65-8.159 8.159c0 38.085 29.926 69.121 67.08 70.159z"></path>
            </g>
        </svg>
    </>
}
const PlusOutlined = ({ ...props }) => {
    return (
        <>
            <span {...props}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 12h16m-8-8v16"
                    ></path>
                </svg>
            </span>
        </>
    );
};

const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
};

const uploadButtonStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #d9d9d9",
    borderRadius: "2px",
    width: "100px",
    height: "100px",
    background: "#fafafa",
    cursor: "pointer",
};

const thumbsContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
};

const thumbStyle = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
};

const thumbInnerStyle = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
    position: "relative",
};

const imgStyle = {
    display: "block",
    width: "auto",
    height: "100%",
};

const CustomUpload = ({
    name = undefined,
    accept = "image/*",
    customRequest = () => { },
    fileList = [],
    onPreview = () => { },
    onRemove = () => { },
    beforeUpload = () => true,
    onChange = () => { },
    onValueChange = () => { },
    multiple = false,
    disabled = false,
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const [files, setFiles] = useState(undefined);

    const { getRootProps, getInputProps } = useDropzone({
        accept,
        multiple,
        onDrop: (acceptedFiles) => {
            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            );
            if (name) {
                onChange({
                    target: {
                        name,
                        value: acceptedFiles?.find((_) => true)
                    }
                })
                onValueChange({
                    target: {
                        name,
                        value: acceptedFiles?.find((_) => true)
                    }
                })
            } else {
                onChange(acceptedFiles?.find((_) => true))
            }
            setFiles((prevFiles) => [
                ...(prevFiles || fileList || []),
                ...newFiles,
            ]);
            customRequest({
                file: acceptedFiles?.find((_) => true),
            });
        },
    });

    const handleRemove = (file) => {
        setFiles((prevFiles) => (prevFiles || fileList || []).filter((f) => f !== file));
        onRemove(file);
    };

    const thumbs = (files || fileList)?.map((file) => (
        <div style={thumbStyle} key={file.name}>
            <div style={thumbInnerStyle}>
                <img
                    src={file.preview}
                    style={imgStyle}
                    onLoad={() => URL.revokeObjectURL(file.preview)}
                    onClick={() => onPreview(file)}
                />
                {
                    !disabled &&
                    <button
                        style={{ position: "absolute", top: 0, right: 0 }}
                        onClick={() => handleRemove(file)}
                    >
                        X
                    </button>
                }

            </div>
        </div>
    ));


    return (
        <div style={containerStyle}>
            {
                !disabled &&
                <div
                    hidden={disabled}
                    {...getRootProps({
                        className: "dropzone",
                        style: uploadButtonStyle,
                    })}
                >
                    <input type={'file'} disabled={disabled} {...getInputProps()} />
                    <PlusOutlined style={{ fontSize: 24, color: "#1890ff" }} />
                    <div style={{ marginTop: 8 }}>Upload</div>
                </div>
            }
            <aside style={thumbsContainerStyle}>{thumbs}</aside>
        </div>
    );
};
export { CustomUpload as Upload };

const LayoutFlow = ({ data }) => {
    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));

    const nodeWidth = 172;
    const nodeHeight = 36;

    const getLayoutedElements = (nodes, edges, direction = "TB") => {
        const isHorizontal = direction === "LR";
        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node) => {
            dagreGraph.setNode(node.id, {
                width: nodeWidth,
                height: nodeHeight,
            });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        const newNodes = nodes.map((node) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            const newNode = {
                ...node,
                targetPosition: isHorizontal ? "left" : "top",
                sourcePosition: isHorizontal ? "right" : "bottom",
                // We are shifting the dagre node position (anchor=center center) to the top left
                // so it matches the React Flow node anchor point (top left).
            };

            return newNode;
        });

        return { nodes: newNodes, edges };
    };
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);

    const onConnect = useCallback(
        (params) =>
            setEdges((eds) =>
                addEdge(
                    {
                        ...params,
                        type: ConnectionLineType.SmoothStep,
                        animated: true,
                    },
                    eds
                )
            ),
        []
    );

    const generateNodesAndEdges = (
        item,
        parentId = null,
        pos = { x: 0, y: 0 }
    ) => {
        const nodes = [];
        const edges = [];
        const nodeId = item.classify_structure_type_id.toString();
        nodes.push({
            id: nodeId,
            type: parentId ? "default" : "input",
            data: { label: item.name },
            position: pos,
        });

        if (parentId) {
            edges.push({
                id: `e${parentId}-${nodeId}`,
                source: parentId,
                target: nodeId,
                type: "smoothstep",
                animated: true,
            });
        }

        const numChildren = item.children.length;
        const totalWidth = (numChildren - 1) * 200;
        const startX = pos.x - totalWidth / 2;

        item.children.forEach((child, index) => {
            const childPos = { x: startX + index * 200, y: pos.y + 100 };
            const result = generateNodesAndEdges(child, nodeId, childPos);
            nodes.push(...result.nodes);
            edges.push(...result.edges);
        });

        return { nodes, edges };
    };

    useEffect(() => {
        if (data) {
            const { nodes, edges } = generateNodesAndEdges(data);
            setNodes(nodes);
            setEdges(edges);
        }
    }, [data]);

    return (
        <ReactFlow
            style={{ minHeight: "500px" }}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            connectionLineType={ConnectionLineType.SmoothStep}
            fitView
        ></ReactFlow>
    );
};
export { LayoutFlow as OrganizationGraph };

const Transfer = ({
    dataSource,
    targetKeys,
    onChange,
    render,
    showSearch,
    listStyle,
}) => {
    const [searchLeft, setSearchLeft] = useState("");
    const [searchRight, setSearchRight] = useState("");
    const [leftItems, setLeftItems] = useState([]);
    const [rightItems, setRightItems] = useState([]);

    useEffect(() => {
        const left = dataSource.filter(
            (item) => !targetKeys.includes(item.key)
        );
        const right = dataSource.filter((item) =>
            targetKeys.includes(item.key)
        );
        setLeftItems(left);
        setRightItems(right);
    }, [dataSource]);

    const handleSearchLeft = (event) => {
        setSearchLeft(event.target.value);
    };
    const handleSearchRight = (event) => {
        setSearchRight(event.target.value);
    };

    const handleTransfer = (
        source,
        setSource,
        destination,
        setDestination,
        keys
    ) => {
        const newSource = source.filter((item) => !keys.includes(item.key));
        const newDestination = [
            ...destination,
            ...keys.map((key) => dataSource.find((item) => item.key === key)),
        ];

        setSource(newSource);
        setDestination(newDestination);
        onChange(newDestination.map((item) => item.key));
    };

    const handleTransferAll = (
        source,
        setSource,
        destination,
        setDestination
    ) => {
        const keys = source.map((item) => item.key);
        handleTransfer(source, setSource, destination, setDestination, keys);
    };

    const filteredLeftItems = leftItems.filter((item) =>
        item.title.includes(searchLeft)
    );
    const filteredRightItems = rightItems.filter((item) =>
        item.title.includes(searchRight)
    );

    return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "45%" }}>
                {showSearch && (
                    <input
                        placeholder="搜尋..."
                        value={searchLeft}
                        onChange={handleSearchLeft}
                    />
                )}
                <div
                    style={{
                        ...listStyle,
                        overflow: "auto",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                    }}
                >
                    {filteredLeftItems.map((item) => (
                        <div key={item.key}>
                            <label>
                                <input
                                    type="checkbox"
                                    value={item.key}
                                    onChange={(e) =>
                                        handleTransfer(
                                            leftItems,
                                            setLeftItems,
                                            rightItems,
                                            setRightItems,
                                            [e.target.value]
                                        )
                                    }
                                />
                                {render(item)}
                            </label>
                        </div>
                    ))}
                </div>
                <button
                    onClick={() =>
                        handleTransferAll(
                            leftItems,
                            setLeftItems,
                            rightItems,
                            setRightItems
                        )
                    }
                >
                    全部往右
                </button>
            </div>
            <div style={{ width: "45%" }}>
                {showSearch && (
                    <input
                        placeholder="搜尋..."
                        value={searchRight}
                        onChange={handleSearchRight}
                    />
                )}
                <div
                    style={{
                        ...listStyle,
                        overflow: "auto",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                    }}
                >
                    {filteredRightItems.map((item) => (
                        <div key={item.key}>
                            <label>
                                <input
                                    type="checkbox"
                                    value={item.key}
                                    onChange={(e) =>
                                        handleTransfer(
                                            rightItems,
                                            setRightItems,
                                            leftItems,
                                            setLeftItems,
                                            [e.target.value]
                                        )
                                    }
                                />
                                {render(item)}
                            </label>
                        </div>
                    ))}
                </div>
                <button
                    onClick={() =>
                        handleTransferAll(
                            rightItems,
                            setRightItems,
                            leftItems,
                            setLeftItems
                        )
                    }
                >
                    全部往左
                </button>
            </div>
        </div>
    );
};
export { Transfer };
const CheckCircleOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                {...props}
            >
                <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="#1C274C"
                    strokeWidth="1.5"
                ></circle>
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M8.5 12.5l2 2 5-5"
                ></path>
            </svg>
        </>
    );
};
const CloseCircleOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 9l6 6m0-6l-6 6m12-3a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
            </svg>
        </>
    );
};
const ExclamationCircleOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 20 20"
                {...props}
            >
                <path
                    fillRule="evenodd"
                    d="M10 3a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0zm10.01 4a1 1 0 01-1 1H10a1 1 0 110-2h.01a1 1 0 011 1zM11 6a1 1 0 10-2 0v5a1 1 0 102 0V6z"
                ></path>
            </svg>
        </>
    );
};
const UserOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                ></path>
            </svg>
        </>
    );
};
export {
    PlusOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    UserOutlined,
    HomeOutlined,
    AudioFilled,
};

const Tag = ({ color = "primary", icon = <></>, children, ...props }) => {
    const colors = {
        default: { backgroundColor: "#e8e8e8", textColor: "#000" },
        primary: { backgroundColor: "#1890ff", textColor: "#fff" },
        secondary: { backgroundColor: "#grey", textColor: "#fff" },
        error: { backgroundColor: "#fff2f0", textColor: "#ff4d4f" },
        success: { backgroundColor: "lightgreen", textColor: "darkgreen" },
        blue: { backgroundColor: "lightblue", textColor: "darkblue" },
        green: { backgroundColor: "lightgreen", textColor: "darkgreen" },
        geekblue: {
            border: "#adc6ff 1px solid",
            backgroundColor: "#f0f5ff",
            textColor: "#1d39c4",
        },
        outline: {
            backgroundColor: "transparent",
            textColor: "#000",
            border: "1px solid #d9d9d9",
        },
        "gold-inverse": {
            backgroundColor: "#faad14",
            textColor: "#fff",
            border: "1px solid #faad14",
        },
        "cyan-inverse": {
            backgroundColor: "#13c2c2",
            textColor: "#fff",
            border: "1px solid #13c2c2",
        },
        // Add other color mappings as needed
    };

    const styles = colors[color] || colors.default;

    return (
        <>
            <Badge
                style={{
                    backgroundColor: styles.backgroundColor,
                    color: styles.textColor,
                    border: styles.border || "none",
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "0 8px",
                    fontSize: "12px",
                    borderRadius: "2px",
                    ...props.style,
                }}
                {...props}
            >
                {icon &&
                    React.cloneElement(icon, {
                        style: {
                            fill: styles.backgroundColor,
                            stroke: styles.textColor,
                            marginRight: "4px",
                        },
                    })}
                {children}
            </Badge>
        </>
    );
};
export { Tag };
const customMessage = () => {
};

customMessage.open = ({ type, content }) => {
    const createContainer = () => {
        const container = document.createElement("div");
        document.getElementById("root").appendChild(container);
        return container;
    };

    const renderToaster = (container) => {
        const root = createRoot(container);
        root.render(
            <>
                <CustomToaster />
            </>
        );
        return root;
    };

    const cleanup = (root, container) => {
        setTimeout(() => {
            root.unmount();
            document.getElementById("root").removeChild(container);
        }, 5000); // Adjust the timeout as needed
    };

    const go = (type, content) => {
        switch (type) {
            case "success":
                toast.success(content);
                break;
            case "info":
                toast.info(content);
                break;
            case "warning":
                toast.warning(content);
                break;
            case "error":
                toast.error(content);
                break;
            case "message":
                toast.content(content);
                break;
            case "loading":
                toast.loading(content);
                break;

            default:
                break;
        }
    }
    if (document.getElementById(toasterId) === null) {
        const container = createContainer();
        const root = renderToaster(container);
        setTimeout(() => {
            go(type, content);
        }, 1000)
    } else {
        go(type, content);

    }
};
customMessage.success = (content) =>
    customMessage.open({ type: "success", content: content });
customMessage.info = (content) =>
    customMessage.open({ type: "info", content: content });
customMessage.warning = (content) =>
    customMessage.open({ type: "warning", content: content });
customMessage.error = (content) =>
    customMessage.open({ type: "error", content: content });
customMessage.message = (content) =>
    customMessage.open({ type: "message", content: content });
customMessage.loading = (content) =>
    customMessage.open({ type: "loading", content: content });

const toasterId = "global-sonner-toaster";
const CustomToaster = ({ ...props }) => {
    if (document.getElementById(toasterId) === null) {
        return (
            <>
                <div id={toasterId}>
                    <Toaster richColors position="top-center" {...props} />
                </div>
            </>
        );
    } else {
        return <></>;
    }
};
export { CustomToaster as Toaster };

const useMessage = () => {
    const createContainer = () => {
        const container = document.createElement("div");
        document.getElementById("root").appendChild(container);
        return container;
    };

    const renderToaster = (container) => {
        const root = createRoot(container);
        root.render(
            <>
                <CustomToaster />
            </>
        );
        return root;
    };

    const cleanup = (root, container) => {
        setTimeout(() => {
            root.unmount();
            document.getElementById("root").removeChild(container);
        }, 5000); // Adjust the timeout as needed
    };
    if (document.getElementById(toasterId) === null) {
        const container = createContainer();
        const root = renderToaster(container);
    }

    return [customMessage];
};
customMessage.useMessage = useMessage;
export { customMessage as message };

const TreeSelect = ({ name, onValueChange = () => { }, multiple = false, defaultValue, showSearch, style, dropdownStyle, placeholder, allowClear, treeDefaultExpandAll, treeNodeFilterProp, onChange = () => { }, treeData, ...props }) => {
    const transformTreeData = (data) => {
        const transformNode = (node) => {
            const internalDefaultValue = (Array.isArray(defaultValue) ? defaultValue : [defaultValue]).map(String);
            const propsValue = (Array.isArray(props?.value) ? props?.value : [props?.value]).map(String);
            const endValue = internalDefaultValue.concat(propsValue);
            return {
                label: node.title,
                value: String(node.value),
                checked: endValue?.includes(String(node.value)),
                expanded: treeDefaultExpandAll,
                children: node?.children?.length > 0 ? node.children.map(transformNode) : [],
            };
        };

        return data.map(transformNode);
    };
    useEffect(() => {
        if (defaultValue) {
            onChange({
                target: {
                    name,
                    value: defaultValue
                }
            })
            onValueChange({
                target: {
                    name,
                    value: defaultValue
                }
            });
        }
    }, [])
    const mode = multiple ? "checkboxSelect" : "radioSelect"
    return (
        <DropdownTreeSelect
            {...props}
            onBlur={() => { }}
            mode={mode}
            data={transformTreeData(treeData)}
            onChange={(currentNode, selectedNodes) => {
                let selectedValue = String(selectedNodes.map(node => node.value)?.find(_ => true));
                if (mode === "checkboxSelect") {
                    selectedValue = selectedNodes.map(node => String(node.value))
                }
                onChange({
                    target: {
                        name,
                        value: selectedValue
                    }
                })
                onValueChange({
                    target: {
                        name,
                        value: selectedValue
                    }
                });
            }}
            texts={{ placeholder }}
        />
    );
};
export { TreeSelect }

const CustomSwitch2 = ({
    name,
    onValueChange = () => { },
    onChange,
    value,
    mode = 'boolean',
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const isChecked = (checked) => {
        if (typeof checked === "string") {
            if (checked === "true" | checked === "1") {
                return true;
            } else {
                return false;
            }
        } else if (typeof checked === "boolean") {
            return checked;
        } else if (typeof checked === "number") {
            if (checked === 1) {
                return true;
            } else {
                return false;
            }
        }
    };

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <CustomSwitchWithMore
                            className={
                                isChecked(value) ? "data-[state=checked]" : ""
                            }
                            checked={isChecked(value)}
                            onCheckedChange={(e) => {
                                let value = e;
                                if (mode === "number") {
                                    value = e ? "1" : "0"
                                } else {
                                    value = e
                                }
                                onChange({
                                    target: {
                                        name,
                                        value: value,
                                        checked: value,
                                    },
                                });
                                onValueChange({
                                    target: {
                                        name,
                                        value: value,
                                        checked: value,
                                    },
                                });
                            }}
                            {...props}
                        />
                    )}
                />
            ) : (
                <CustomSwitchWithMore
                    checked={value}
                    onCheckedChange={(e) => {
                        let value = e;
                        if (mode === "number") {
                            value = e ? "1" : "0"
                        } else {
                            value = e
                        }
                        onChange({
                            target: {
                                name,
                                value: value,
                            },
                        });
                        onValueChange({
                            target: {
                                name,
                                value: value,
                            },
                        });
                    }}
                    {...props}
                />
            )}
        </>
    );
};
export { CustomSwitch2 as Switch };

const InputPassword = ({ ...props }) => {
    const [value, setValue] = useState(String(props?.value) || 0)
    useEffect(() => {
        setValue(props?.value)
    }, [props?.value])
    return <>

        {props?.name ? (
            <Input
                type={"password"}
                value={value}
                onChange={e => {
                    props?.onValueChange({
                        target: {
                            name: props?.name,
                            value: e.target.value
                        }
                    });
                    props?.onChange({
                        target: {
                            name: props?.name,
                            value: e.target.value
                        }
                    });
                    setValue(e.target.value)
                }}
            />)
            : <>
                <Input {...props} type={"password"} />
            </>}
    </>;
};
Input.Password = InputPassword
Input.TextArea = Textarea
export { Input };

const CustomPie = ({ ...config }) => {
    const {
        appendPadding = 10,
        data = [],
        angleField = "value",
        colorField = "type",
        radius = 0.9,
        label = {
            type: "inner",
            offset: "-30%",
            content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
            style: {
                fontSize: 15,
                textAlign: "center",
            },
        },
        interactions = [
            {
                type: "element-active",
            },
        ],
        style = { maxHeight: "20vh" },
    } = config;
    const svgRef = useRef();
    function vhToPixels(vh) {
        return Math.round(window.innerHeight * (vh / 100));
    }

    useEffect(() => {
        const internalData = data.filter((item) => item.value !== 0);
        const svg = d3.select(svgRef.current);
        const width = String(style?.maxHeight).indexOf("vh")
            ? vhToPixels(parseInt(String(style?.maxHeight).replace("vh", "")))
            : style?.maxHeight || 400;
        const height = width;
        const radius = (Math.min(width, height) / 2) * config.radius;

        // Clear previous chart
        svg.selectAll("*").remove();

        // Setup the svg element
        svg.attr("width", width).attr("height", height);
        const g = svg
            .append("g")
            .attr("transform", `translate(${width / 2}, ${height / 2})`);

        // Setup color scale
        const color = d3.scaleOrdinal(d3.schemeCategory10);

        // Generate the pie
        const pie = d3
            .pie()
            .sort(null)
            .value((d) => d[config.angleField]);

        // Generate the arcs
        const arc = d3.arc().innerRadius(0).outerRadius(radius);

        // Generate the arcs for labels
        const labelArc = d3
            .arc()
            .innerRadius(radius * 0.6)
            .outerRadius(radius * 0.6);

        // Append the arcs
        const path = g
            .selectAll("path")
            .data(pie(internalData))
            .enter()
            .append("path")
            .attr("d", arc)
            .attr("fill", (d) => color(d.data[config.colorField]));

        // Append the labels
        g.selectAll("text")
            .data(pie(internalData))
            .enter()
            .append("text")
            .attr("transform", (d) => `translate(${labelArc.centroid(d)})`)
            .attr("dy", "0.35em")
            .attr("text-anchor", "middle")
            .style("font-size", `${config.label.style.fontSize}px`)
            .text(
                (d) =>
                    `${d.data?.type}：${Math.round(
                        (d.data[config.angleField] /
                            d3.sum(data, (d) => d[config.angleField])) *
                        100
                    )}%`
            );

        // Interaction for element active
        path.on("mouseover", function () {
            d3.select(this)
                .transition()
                .duration(200)
                .attr(
                    "d",
                    d3
                        .arc()
                        .innerRadius(0)
                        .outerRadius(radius * 1.1)
                );
        });
        path.on("mouseout", function () {
            d3.select(this).transition().duration(200).attr("d", arc);
        });
    }, [data, config]);

    return <svg ref={svgRef} style={config.style} />;
};
export { CustomPie as Pie };

const CustomCheckbox = ({ children, ...props }) => {
    return (
        <>
            <div className="flex items-center space-x-2">
                <Checkbox {...props} />
                <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    {children}
                </label>
            </div>
        </>
    );
};
const CustomCheckboxGroup = ({
    defaultValue = [],
    disabled = false,
    name,
    options = [],
    value: controlledValue,
    onChange,
    style,
    children,
}) => {
    const [selectedValues, setSelectedValues] = useState(
        controlledValue || defaultValue
    );

    useEffect(() => {
        if (controlledValue !== undefined) {
            setSelectedValues(controlledValue);
        }
    }, [controlledValue]);

    const handleChange = (checked, optionValue) => {
        const newValues = checked
            ? [...selectedValues, optionValue]
            : selectedValues.filter((val) => val !== optionValue);
        if (controlledValue === undefined) {
            setSelectedValues(newValues);
        }

        if (onChange) {
            onChange(newValues);
        }
    };

    const renderChildren = (children) => {
        return React.Children.map(children, (child) => {
            if (child && child?.type === CustomCheckbox) {
                return cloneElement(child, {
                    checked: selectedValues.includes(child.props.value),
                    onCheckedChange: (e) => {
                        handleChange(e, child.props.value);
                    },
                    disabled: disabled || child.props.disabled,
                    name,
                });
            }

            if (child && child.props && child.props.children) {
                return cloneElement(child, {
                    children: renderChildren(child.props.children),
                });
            }

            return child;
        });
    };
    return (
        <div style={style}>
            <Row gutter={[16, 16]}>
                {options.length > 0
                    ? options.map((option) => (
                        <Col span={12} key={option.value}>
                            <CustomCheckbox
                                checked={selectedValues.includes(
                                    option.value
                                )}
                                onChange={(e) => {
                                    handleChange(
                                        e.target.checked,
                                        option.value
                                    );
                                }}
                                value={option.value}
                                disabled={disabled || option.disabled}
                                name={name}
                            >
                                {option.label}
                            </CustomCheckbox>
                        </Col>
                    ))
                    : renderChildren(children)}
            </Row>
        </div>
    );
};
CustomCheckbox.Group = CustomCheckboxGroup;
export { CustomCheckbox as Checkbox };

const CustomCarousel = ({
    arrows = false,
    autoplay = false,
    autoplaySpeed = 3000,
    adaptiveHeight = false,
    dotPosition = "bottom",
    dots = true,
    draggable = false,
    fade = false,
    infinite = true,
    speed = 500,
    easing = "linear",
    effect = "scrollx",
    afterChange,
    beforeChange,
    waitForAnimate = false,
    children,
}) => {
    const [current, setCurrent] = useState(0);
    const [autoPlayId, setAutoPlayId] = useState(null);

    useEffect(() => {
        if (autoplay) {
            const id = setInterval(() => {
                const nextIndex =
                    (current + 1) % React.Children.count(children);
                handleChange(nextIndex);
            }, autoplaySpeed);
            setAutoPlayId(id);

            return () => clearInterval(id);
        }
    }, [autoplay, autoplaySpeed, current, children]);

    const handleChange = (nextIndex) => {
        if (beforeChange) {
            beforeChange(current, nextIndex);
        }

        if (!waitForAnimate || !fade) {
            setCurrent(nextIndex);
        }

        if (afterChange) {
            afterChange(nextIndex);
        }
    };

    return (
        <div className={`carousel-container ${dotPosition}`}>
            <Carousel
                index={current}
                onIndexChange={handleChange}
                transitionDuration={speed}
                transitionTimingFunction={easing}
                infinite={infinite}
                className={`${effect === "fade" ? "fade" : ""}`}
            >
                {React.Children.map(children, (child, index) => (
                    <CarouselItem
                        key={index}
                        className={`${adaptiveHeight ? "adaptive-height" : ""}`}
                    >
                        {child}
                    </CarouselItem>
                ))}
            </Carousel>

            {dots && (
                <div className={`dots ${dotPosition}`}>
                    {React.Children.map(children, (child, index) => (
                        <button
                            key={index}
                            className={`dot ${current === index ? "active" : ""
                                }`}
                            onClick={() => handleChange(index)}
                        />
                    ))}
                </div>
            )}

            {arrows && (
                <div className="arrows">
                    <button
                        className="arrow prev"
                        onClick={() =>
                            handleChange(
                                (current - 1 + React.Children.count(children)) %
                                React.Children.count(children)
                            )
                        }
                    >
                        {"<"}
                    </button>
                    <button
                        className="arrow next"
                        onClick={() =>
                            handleChange(
                                (current + 1) % React.Children.count(children)
                            )
                        }
                    >
                        {">"}
                    </button>
                </div>
            )}
        </div>
    );
};
export { CustomCarousel as Carousel };

const CustomAvatar = ({ size = "default", src, icon, ...props }) => {
    const sizeMap = {
        large: 64,
        default: 40,
        small: 32,
    };

    const sizeValue = typeof size === "string" ? sizeMap[size] : size;

    return (
        <>
            <Avatar
                style={{
                    width:
                        typeof sizeValue === "number" ? sizeValue : undefined,
                    height:
                        typeof sizeValue === "number" ? sizeValue : undefined,
                    fontSize:
                        typeof sizeValue === "number"
                            ? sizeValue / 2
                            : undefined,
                }}
                {...props}
            >
                {src ? (
                    <img
                        src={src}
                        alt="avatar"
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                        }}
                    />
                ) : (
                    React.cloneElement(icon, {
                        width:
                            typeof sizeValue === "number"
                                ? sizeValue
                                : undefined,
                        height:
                            typeof sizeValue === "number"
                                ? sizeValue
                                : undefined,
                        fontSize:
                            typeof sizeValue === "number"
                                ? sizeValue / 2
                                : undefined,
                        ...props,
                    }) || <></>
                )}
            </Avatar>
        </>
    );
};
export { CustomAvatar as Avatar };

const Seperator = styled.div`
    & {
        display: flex;
        align-items: center;
        text-align: center;
    }

    &::before,
    &::after {
        content: "";
        flex: 1;
        border-bottom: 1px solid #000;
    }

    &:not(:empty)::before {
        margin-right: 0.5em;
    }

    &:not(:empty)::after {
        margin-left: 0.5em;
    }
`;
export { Seperator };

const CustomTabs = ({
    activeKey,
    defaultActiveKey,
    items = [],
    onChange,
    animated = { inkBar: true, tabPane: false },
    centered = false,
    tabBarExtraContent,
    tabBarGutter,
    tabBarStyle,
    tabPosition = "top",
    destroyInactiveTabPane = false,
    type = "line",
    onEdit,
    onTabClick,
    onTabScroll,
    size = "middle",
    moreIcon,
    addIcon,
    hideAdd = false,
    popupClassName,
    renderTabBar,
}) => {
    const [activeTab, setActiveTab] = React.useState(
        defaultActiveKey ?? (items.length > 0 ? items[0].key : "")
    );
    React.useEffect(() => {
        if (activeKey) {
            setActiveTab(activeKey);
        }
    }, [activeKey]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        if (onChange) {
            onChange(key);
        }
    };

    return (
        <div
            className={`custom-tabs ${centered ? "centered" : ""}`}
            style={tabBarStyle}
        >
            {tabBarExtraContent && (
                <div className="tab-bar-extra-content">
                    {tabBarExtraContent}
                </div>
            )}
            <Tabs defaultValue={activeTab} onValueChange={handleTabChange}>
                <TabsList className="custom-tabs-list">
                    {items.map((item) => (
                        <TabsTrigger key={item.key} value={item.key}>
                            {item.tab}
                        </TabsTrigger>
                    ))}
                </TabsList>
                {items.map((item) => (
                    <TabsContent key={item.key} value={item.key}>
                        {item.content}
                    </TabsContent>
                ))}
            </Tabs>
        </div>
    );
};

export { CustomTabs as Tabs };
export { TabsContent, TabsList, TabsTrigger }

const InputNumber = ({ min, max, disabled = false, ...props }) => {
    const formContext = useFormContext();
    const [value, setValue] = useState(String(props?.value) || 0)
    useEffect(() => {
        setValue(props?.value)
    }, [props?.value])
    return (
        <>
            {props?.name ? (
                <Input
                    // {...props}
                    disabled={disabled}
                    value={value}
                    onChange={(e) => {
                        const floatRegex = /^-?\d*\.?\d*$/;
                        if (floatRegex.test(e.target.value)) {
                            let newValue = e.target.value
                            if (!!max && parseFloat(newValue) > parseFloat(max)) {
                                newValue = max
                            }
                            if (!!`${min}` && parseFloat(newValue) < parseFloat(min)) {
                                newValue = min
                            }
                            props?.onValueChange({
                                target: {
                                    name: props?.name,
                                    value: newValue
                                }
                            });
                            props?.onChange({
                                target: {
                                    name: props?.name,
                                    value: newValue
                                }
                            });
                            setValue(newValue)
                        }
                    }}
                />
            ) : (
                <Input
                    {...props} />
            )}
        </>
    );
};

export { InputNumber };
const CustomColorPicker = ({
    modal = true,
    //請先用做基本的如果沒有動作，那就是沒有功能 ＱＱ
    allowClear = false,
    arrow = { pointAtCenter: true },
    children,
    defaultValue = "#000",
    defaultFormat = "hex",
    disabled = false,
    // disabledAlpha = false,
    // destroyTooltipOnHide = false,
    format = "hex", //目前還沒辦法轉換
    // mode = ["single"], 目前沒有
    open,
    presets = [],
    placement = "bottomLeft",
    panelRender,
    showText = true,
    size = "medium",
    trigger = "click",
    value,
    onChange = () => { },
    onChangeComplete,
    onFormatChange,
    onOpenChange,
    onClear,
    onValueChange = () => { },
    name,
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [color, setColor] = useState(value || defaultValue);
    const [isOpen, setIsOpen] = useState(open || false);

    const handleColorChange = (newColor) => {
        setColor(newColor);

        onValueChange({
            target: {
                name: name,
                value: newColor,
            },
        });
        if (onChange) {
            onChange({
                target: {
                    name: name,
                    value: newColor,
                },
            });
        }
    };

    const handleColorChangeComplete = () => {
        if (onChangeComplete) onChangeComplete(color);
    };

    const handleClear = () => {
        setColor("");
        if (onClear) onClear();
    };

    const handleFormatChange = (newFormat) => {
        if (onFormatChange) onFormatChange(newFormat);
    };

    const handleOpenChange = (isOpen) => {
        setIsOpen(isOpen);
        if (onOpenChange) onOpenChange(isOpen);
    };

    const renderColorPicker = (control) => {
        if (control) {
            switch (format) {
                case "rgb":
                    return (
                        <RgbColorPicker
                            color={value}
                            onChange={handleColorChange}
                        />
                    );
                default:
                    return (
                        <HexColorPicker
                            color={value}
                            onChange={handleColorChange}
                        />
                    );
            }
        } else {
            switch (format) {
                case "rgb":
                    return (
                        <RgbColorPicker
                            color={color}
                            onChange={handleColorChange}
                        />
                    );
                default:
                    return (
                        <HexColorPicker
                            color={color}
                            onChange={handleColorChange}
                        />
                    );
            }
        }
    };

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <Popover
                            modal={true}
                            open={isOpen} onOpenChange={handleOpenChange}>
                            <PopoverTrigger asChild>
                                <Button
                                    type="button"
                                    disabled={disabled}
                                    variant={"outline"}
                                >
                                    <Row gutter={[4, 4]} align={"middle"}>
                                        <Col>
                                            <div
                                                style={{
                                                    width: "20vw", // 使用 vw 單位以便在不同寬度的設備上保持響應式
                                                    height: "20vw", // 高度設置為和寬度相同，保持正方形
                                                    maxWidth: "20px", // 設置最大寬度
                                                    maxHeight: "20px", // 設置最大高度
                                                    minWidth: "15px", // 設置最小寬度
                                                    minHeight: "15px", // 設置最小高度
                                                    backgroundColor: value,
                                                    borderRadius: "4px",
                                                }}
                                            ></div>
                                        </Col>
                                        <Col>
                                            {children ||
                                                (showText && value) ||
                                                "選擇顏色"}
                                        </Col>
                                    </Row>
                                </Button>
                            </PopoverTrigger>
                            <PopoverContent
                                className={`z-100 w-64  ${arrow.pointAtCenter ? "arrow-center" : ""
                                    }`}
                                style={{
                                    zIndex: 100
                                }}
                                placement={placement}
                            >
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Row justify={"center"}>
                                            <Col>
                                                {panelRender
                                                    ? panelRender(
                                                        renderColorPicker(),
                                                        {
                                                            components: {
                                                                Picker: renderColorPicker,
                                                            },
                                                        }
                                                    )
                                                    : renderColorPicker()}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row justify={"end"}>
                                            <Col>
                                                <Input
                                                    maxlength="7"
                                                    className={"h-8"}
                                                    style={{
                                                        width: "7rem",
                                                    }}
                                                    value={value}
                                                    onChange={(e) => {
                                                        onValueChange({
                                                            target: {
                                                                ...e.target,
                                                                value: e.target
                                                                    .value,
                                                            },
                                                        });
                                                        setColor(
                                                            e.target.value
                                                        );
                                                    }}
                                                ></Input>
                                            </Col>
                                            <Col>
                                                {allowClear && (
                                                    <Button
                                                        size="small"
                                                        onClick={handleClear}
                                                        variant="secondary"
                                                    >
                                                        清除
                                                    </Button>
                                                )}
                                            </Col>
                                            <Col>
                                                <Button
                                                    variant={"ghost"}
                                                    size={"small"}
                                                    onClick={
                                                        handleColorChangeComplete
                                                    }
                                                >
                                                    {trigger === "click"
                                                        ? "確認"
                                                        : "關閉"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <div className="mt-4 flex justify-between"></div>
                                        {presets.length > 0 && (
                                            <div className="mt-4">
                                                {presets.map(
                                                    (preset, index) => (
                                                        <div key={index}>
                                                            <p>
                                                                {preset.label}
                                                            </p>
                                                            <div className="flex space-x-2">
                                                                {preset?.colors.map(
                                                                    (
                                                                        presetColor,
                                                                        i
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                i
                                                                            }
                                                                            className="w-6 h-6"
                                                                            style={{
                                                                                backgroundColor:
                                                                                    presetColor,
                                                                            }}
                                                                            onClick={() =>
                                                                                handleColorChange(
                                                                                    presetColor
                                                                                )
                                                                            }
                                                                        />
                                                                    )
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                {/* <div className="mt-2 flex space-x-2">
                            <Button
                                size={"small"}
                                variant="outline"
                                onClick={() => handleFormatChange("hex")}
                            >
                                HEX
                            </Button>
                            <Button
                                size={"small"}
                                variant="outline"
                                onClick={() => handleFormatChange("rgb")}
                            >
                                RGB
                            </Button>
                        </div> */}
                            </PopoverContent>
                        </Popover>
                    )}
                />
            ) : (
                <Popover
                    modal={true}
                    open={isOpen} onOpenChange={handleOpenChange}>
                    <PopoverTrigger asChild>
                        <Button
                            type="button"
                            size={size}
                            disabled={disabled}
                            variant={"outline"}
                        >
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <div
                                        style={{
                                            width: "20vw", // 使用 vw 單位以便在不同寬度的設備上保持響應式
                                            height: "20vw", // 高度設置為和寬度相同，保持正方形
                                            maxWidth: "20px", // 設置最大寬度
                                            maxHeight: "20px", // 設置最大高度
                                            minWidth: "15px", // 設置最小寬度
                                            minHeight: "15px", // 設置最小高度
                                            backgroundColor: color,
                                            borderRadius: "4px",
                                        }}
                                    ></div>
                                </Col>
                                <Col>
                                    {children ||
                                        (showText && color) ||
                                        "選擇顏色"}
                                </Col>
                            </Row>
                        </Button>
                    </PopoverTrigger>
                    <PopoverContent
                        className={`w-64  ${arrow.pointAtCenter ? "arrow-center" : ""
                            }`}
                        placement={placement}
                    >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Row justify={"center"}>
                                    <Col>
                                        {panelRender
                                            ? panelRender(renderColorPicker(), {
                                                components: {
                                                    Picker: renderColorPicker,
                                                },
                                            })
                                            : renderColorPicker()}
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row justify={"end"}>
                                    <Col>
                                        <Input
                                            maxlength="7"
                                            className={"h-8"}
                                            style={{
                                                width: "7rem",
                                            }}
                                            value={color}
                                            onChange={(e) => {
                                                setColor(e.target.value);
                                            }}
                                        ></Input>
                                    </Col>
                                    <Col>
                                        {allowClear && (
                                            <Button
                                                size="small"
                                                onClick={handleClear}
                                                variant="secondary"
                                            >
                                                清除
                                            </Button>
                                        )}
                                    </Col>
                                    <Col>
                                        <Button
                                            variant={"ghost"}
                                            size={"small"}
                                            onClick={handleColorChangeComplete}
                                        >
                                            {trigger === "click"
                                                ? "確認"
                                                : "關閉"}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <div className="mt-4 flex justify-between"></div>
                                {presets.length > 0 && (
                                    <div className="mt-4">
                                        {presets.map((preset, index) => (
                                            <div key={index}>
                                                <p>{preset.label}</p>
                                                <div className="flex space-x-2">
                                                    {preset?.colors.map(
                                                        (presetColor, i) => (
                                                            <div
                                                                key={i}
                                                                className="w-6 h-6"
                                                                style={{
                                                                    backgroundColor:
                                                                        presetColor,
                                                                }}
                                                                onClick={() =>
                                                                    handleColorChange(
                                                                        presetColor
                                                                    )
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </Col>
                        </Row>

                        {/* <div className="mt-2 flex space-x-2">
                    <Button
                        size={"small"}
                        variant="outline"
                        onClick={() => handleFormatChange("hex")}
                    >
                        HEX
                    </Button>
                    <Button
                        size={"small"}
                        variant="outline"
                        onClick={() => handleFormatChange("rgb")}
                    >
                        RGB
                    </Button>
                </div> */}
                    </PopoverContent>
                </Popover>
            )}
        </>
    );
};

export { CustomColorPicker as ColorPicker };
const CustomMultipleSelector = ({ name, value, onValueChange, ...props }) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                        //目前 Form 會強行轉成套件關係 set 陣列要先 stringify
                        //這裡會 再parse轉回來
                        let temp = value;
                        if (typeof temp === "string" && temp !== "") {
                            temp = JSON.parse(temp);
                        }
                        return (
                            <MultipleSelector
                                {...props}
                                onChange={(val) => {
                                    onValueChange({
                                        target: {
                                            value: val,
                                        },
                                    });
                                }}
                                value={temp || []}
                            />
                        );
                    }}
                />
            ) : (
                <MultipleSelector {...props} />
            )}
        </>
    );
};
export { CustomMultipleSelector as MultipleSelector };

const jsonToQueryString = (json) => {
    return new URLSearchParams(json).toString();
};
export { jsonToQueryString }

const CustomMultipleSelectorV2 = ({ name, value, onValueChange, options, ...props }) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const values2LabelValues = (values) => {
        let labelValues = (options || []).filter((option) => {
            return values.includes(option?.value)
        })
        return labelValues
    }

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                        return (
                            <MultipleSelector
                                {...props}
                                options={options}
                                onChange={(selectLabelValues) => {
                                    let selectValues = selectLabelValues.map((selectLabelValue) => selectLabelValue?.value)
                                    onValueChange({
                                        target: {
                                            value: selectValues,
                                        },
                                    });
                                }}
                                value={values2LabelValues(value) || []}
                            />
                        );
                    }}
                />
            ) : (
                <MultipleSelector
                    options={options}
                    {...props}
                    value={values2LabelValues(value)}

                />
            )}
        </>
    );
}
export { CustomMultipleSelectorV2 as MultipleSelectorV2 };


const MainModal = (
    {
        axiosMode = "post",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        onFinish = () => {

        },
        width,
        formElement = <div></div>,
        keyPrefix
    }
) => {
    const { t: tProps } = useTranslation('translation', { keyPrefix: keyPrefix })
    const { t: tDefault } = useTranslation('translation')
    const t = keyPrefix ? tProps : tDefault
    const axiosModelanguage = {
        get: t('get'),
        post: t('post'),
        patch: t('patch'),
        delete: t('delete'),
    }
    const [form] = CustomForm.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }
    const handleGenerate = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    return <>
        {
            propsOpen === null &&
            <CustomButton type="primary" onClick={showModal}>
                {
                    `${axiosModelanguage[axiosMode]}${t('data')}`
                }
            </CustomButton>
        }

        <CustomModal
            style={{ top: 10 }}
            title={`${axiosModelanguage[axiosMode]}${t('data')}`}
            open={propsOpen === null ? isModalOpen : propsOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={propsLoading === null ? loading : propsLoading}
            maskClosable={false}
            contentStyle={{
                padding: 16
            }}
            width={width}
            okText={t('submit')}
            cancelText={t('cancel')}
        >
            <Row
                style={{
                    maxHeight: "80vh",
                    minHeight: "30vh",
                    // overflowX: "scroll",
                    // overflowY: "scroll",
                    overflow: "visable"
                }}
            >
                <Col span={24}>
                    {React.cloneElement(formElement, {
                        formReloadCount: formReloadCount,
                        open: propsOpen === null ? isModalOpen : propsOpen,
                        axiosMode: axiosMode,
                        propsForm: propsForm ? propsForm : form,
                        onFormFinish: onFormFinish,
                    })}
                </Col>
            </Row>
        </CustomModal>
    </>
}
export { MainModal }

const getSpaceAlignItems = (align) => {
    switch (align) {
        case 'start':
            return 'flex-start';
        case 'end':
            return 'flex-end';
        case 'center':
            return 'center';
        case 'baseline':
            return 'baseline';
        default:
            return 'flex-start';
    }
};

const getSpaceDirection = (direction) => {
    return direction === 'vertical' ? 'column' : 'row';
};

const getSpaceGap = (size) => {
    if (Array.isArray(size)) {
        const [horizontal, vertical] = size;
        return `${vertical}px ${horizontal}px`;
    }
    return `${size}px`;
};

const SpaceWrapper = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => getSpaceDirection(direction)};
    flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
    align-items: ${({ align }) => getSpaceAlignItems(align)};
    gap: ${({ size }) => getSpaceGap(size)};
`;

const Space = ({ align = 'start', direction = 'horizontal', size = 'small', wrap = false, children, ...props }) => {
    return (
        <SpaceWrapper align={align} direction={direction} size={size} wrap={wrap} {...props}>
            {children}
        </SpaceWrapper>
    );
};

export { Space };

export { ClassifyStructure }
const ExpandableText = ({
    style,
    text,
    maxLines,
    minHeight = false,
    alwaysShowButton = false, // 新增屬性來控制是否保留按鈕佔位
    expandedStyle = "icon"//顯示使用圖示或文字
}) => {
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);
    const [calculatedMinHeight, setCalculatedMinHeight] = useState('');

    const calculateOverflow = () => {
        if (textRef.current) {
            const totalHeight = textRef.current.scrollHeight;
            const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
            const visibleHeight = lineHeight * maxLines;

            // 設置 minHeight 為動態計算出的行高
            if (minHeight) {
                setCalculatedMinHeight(`${lineHeight * maxLines}px`);
            }

            setIsOverflowing(totalHeight > visibleHeight);
        }
    };

    useEffect(() => {
        calculateOverflow(); // 初次渲染時計算是否超過行數

        const handleResize = () => {
            calculateOverflow(); // 畫面變動時重新計算
        };

        window.addEventListener('resize', handleResize); // 監聽窗口變動

        return () => {
            window.removeEventListener('resize', handleResize); // 清理事件監聽器
        };
    }, [text, maxLines, minHeight]);

    const toggleExpand = () => {
        setExpanded(!expanded);
    };

    const textStyle = {
        display: '-webkit-box',
        WebkitLineClamp: expanded ? 'unset' : maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '1.5', // 假設默認行高為1.5em，可以根據實際樣式調整
        whiteSpace: 'pre-wrap', // 確保文本中的 \n 能夠換行

    };

    return (
        <Row>
            <Col
                span={24}
                style={{
                    minHeight: minHeight ? calculatedMinHeight : '' // 動態設置最小高度
                }}
            >
                <p ref={textRef} style={{ ...textStyle, ...style }}>{text}</p>
            </Col>
            <Col span={24}>
                {isOverflowing || alwaysShowButton ? (
                    <button
                        onClick={toggleExpand}
                        type="link"
                        style={{
                            visibility: isOverflowing ? 'visible' : 'hidden', // 當文本沒溢出時，隱藏按鈕但保留佔位
                            color: expanded ? "#6EACDA" : "#FB773C"
                        }}
                    >
                        {expanded
                            ?
                            (expandedStyle === "icon" ? <ChevronUp /> : "收起")
                            :
                            (expandedStyle === "icon" ? <ChevronDown /> : "展開")
                        }

                    </button>
                ) : null}
            </Col>
        </Row>
    );
};
export { ExpandableText }
const CustomSkeleton = ({ }) => {
    return <>
        <div className="flex flex-col space-y-3">
            <Skeleton className="h-[125px] w-[80vw] rounded-xl" />
            <div className="space-y-2">
                <Skeleton className="h-4 w-[60vw]" />
                <Skeleton className="h-4 w-[60vw]" />
            </div>
        </div>
    </>
}
export { CustomSkeleton as Skeleton }


const EditorContainer = styled.div`
    &{
        z-index: 99999
    }
    .jodit-popup{
        position: absolute;
        top:0 !important;
        left:0 !important;
    }
    .jodit-dialog__panel{
        position: fixed;
        top:0 !important;
        left:0 !important;
    }
`
const CustomJoditEditor = forwardRef((
    {
        propsHidden = false,
        ...props
    },
    ref
) => {
    const editorContainerRef = useRef(null);
    const popoverRef = useRef(null);
    useEffect(() => {
        const moveJoditPopups = () => {
            if (!!propsHidden) {
                return;
            }
            const joditPopups = document.querySelectorAll('.jodit-popup');
            const joditDialog = document.querySelectorAll('.jodit.jodit-dialog');
            joditPopups.forEach(popup => {
                if (popoverRef.current && !popoverRef.current.contains(popup)) {
                    popoverRef.current.appendChild(popup);
                    const firstInput = popoverRef.current?.querySelector('input');
                    if (firstInput) {
                        firstInput.focus(); // Set focus on the first input
                        popoverRef.current.scrollIntoView()
                    }
                }
            });
            joditDialog.forEach(popup => {
                if (editorContainerRef.current && !editorContainerRef.current.contains(popup)) {
                    editorContainerRef.current.appendChild(popup);
                    const firstInput = editorContainerRef.current?.querySelector('input');
                    if (firstInput) {
                        firstInput.focus(); // Set focus on the first input
                        editorContainerRef.current.scrollIntoView()
                    }
                }
            });
        };

        // Add event listeners if necessary when Jodit generates new elements
        const observer = new MutationObserver(moveJoditPopups);
        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();

    }, [])
    return <EditorContainer
        ref={editorContainerRef}
    >
        <div style={{ position: 'relative', zIndex: 99999 }} ref={popoverRef}
            onMouseDown={(e) => e.stopPropagation()} // Stop clicks from propagating
            onBlur={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation()
            }}
        />
        <JoditEditor
            ref={ref}
            {...props}
        />
    </EditorContainer>
})
export { CustomJoditEditor as JoditEditor }

const TimeSelector = ({
    initialSelectedTimes = [],    // 已選時間陣列
    initialDisabledTimes = [],    // 不可選時間陣列
    slotInterval = 60,            // 時間槽間隔，預設為 60 分鐘
    maxHours,                  // 最大選擇時數上限
    selectableRanges = ["00:00-23:59"],  // 可選範圍
    customSelectedTimes = [],
    setCustomSelectedTimes = () => { },
    onChange = () => { },
    onValueChange = () => { },
    name,
    value,
}) => {
    const [selectedTimes, setSelectedTimes] = useState(new Set(initialSelectedTimes));
    const [disabledTimes, setDisabledTimes] = useState(new Set(initialDisabledTimes));
    const [isDragging, setIsDragging] = useState(false);
    const formContext = useFormContext();

    const control = formContext ? formContext.control : undefined;

    // 定義樣式
    const selectableStyle = 'bg-green-100 text-green-900 hover:bg-green-200';
    const selectedStyle = 'bg-blue-500 text-white';
    const disabledStyle = 'bg-pink-200 text-gray-500 cursor-not-allowed';

    // 確認時間是否在可選範圍內
    const isWithinSelectableRange = (time) => {
        const [start, end] = time?.split("-").map(t => new Date(`1970-01-01T${t}:00`));
        if (selectableRanges.length > 0) {
            return selectableRanges.some(range => {
                if (range) {
                    const [rangeStart, rangeEnd] = range?.split("-").map(t => new Date(`1970-01-01T${t}:00`));
                    return start >= rangeStart && end <= rangeEnd;
                } else {
                    return true && true;
                }
            });
        } else {
            return true && true;
        }

    };

    // 計算時間段
    const hours = Array.from({ length: (24 * 60) / slotInterval }, (_, i) => {
        const start = new Date();
        start.setHours(0, i * slotInterval, 0, 0);
        const end = new Date(start);
        end.setMinutes(59); // 設置結束時間為該小時的59分
        const timeSlot = `${start.toTimeString().slice(0, 5)}-${end.toTimeString().slice(0, 5)}`;
        return {
            time: timeSlot,
            disabled: disabledTimes.has(timeSlot) || !isWithinSelectableRange(timeSlot),
        };
    });

    // 處理時間選擇
    const handleSlotClick = (hour) => {
        if (hour.disabled) return;

        const updatedTimes = new Set(selectedTimes);
        if (updatedTimes.has(hour.time)) {
            updatedTimes.delete(hour.time);
        } else {
            if (maxHours && (updatedTimes.size + 1) * slotInterval / 60 > maxHours) {
                customMessage.error(`選擇的時間超過上限 ${maxHours} 小時`);
                return;
            } else {
                updatedTimes.add(hour.time);
            }
        }
        onChange(
            {
                target: {
                    name: name,
                    value: [...updatedTimes]
                }
            }
        )
        onValueChange(
            {
                target: {
                    name: name,
                    value: [...updatedTimes]
                }
            }
        )
        setCustomSelectedTimes(updatedTimes);
        setSelectedTimes(updatedTimes);
    };

    const handleMouseDown = (hour) => {
        if (hour.disabled) return;
        setIsDragging(true);
        handleSlotClick(hour);
    };

    const handleMouseOver = (hour) => {
        if (isDragging && !hour.disabled) {
            handleSlotClick(hour);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    // 獲取已選時間段並排序
    const getSelectedSlots = () => {
        const sortedTimes = Array.from(selectedTimes).sort((a, b) => {
            const [aStart] = a.split(' - ');
            const [bStart] = b.split(' - ');
            return new Date(`1970-01-01T${aStart}:00`) - new Date(`1970-01-01T${bStart}:00`);
        });

        customMessage.success(`已選擇的時間區段：\n${sortedTimes.join('\n')}`);
    };

    const totalHours = (selectedTimes.size * slotInterval) / 60;

    useEffect(() => {
        setSelectedTimes(new Set(initialSelectedTimes ? initialSelectedTimes?.concat(value || []) : value));
        setDisabledTimes(new Set(initialDisabledTimes));
    }, [initialSelectedTimes, initialDisabledTimes, value]);

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                        return (
                            <div className="p-4">
                                <div
                                    className="grid gap-2"
                                    style={{
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
                                    }}
                                    onMouseUp={handleMouseUp}
                                >
                                    {hours.map((hour, index) => (
                                        <button
                                            key={index}
                                            type="button"  // 防止按鈕觸發表單提交
                                            onMouseDown={() => handleMouseDown(hour)}
                                            onMouseOver={() => handleMouseOver(hour)}
                                            onMouseUp={handleMouseUp}
                                            className={`border p-2 rounded-md text-sm font-medium transition-all duration-300 ${hour.disabled ? disabledStyle : selectedTimes.has(hour.time) ? selectedStyle : selectableStyle
                                                }`}
                                            disabled={hour?.disabled}
                                        >
                                            {hour?.time}
                                        </button>
                                    ))}
                                </div>

                                <Row className="mt-4 text-center">
                                    <Col className="text-lg font-medium" span={24}>
                                        總時數：{totalHours} 小時
                                    </Col>
                                </Row>
                            </div>
                        );
                    }}
                />
            ) : (
                <div className="p-4">
                    <div
                        className="grid gap-2"
                        style={{
                            gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
                        }}
                        onMouseUp={handleMouseUp}
                    >
                        {hours.map((hour, index) => (
                            <button
                                key={index}
                                type="button"  // 防止按鈕觸發表單提交
                                onMouseDown={() => handleMouseDown(hour)}
                                onMouseOver={() => handleMouseOver(hour)}
                                onMouseUp={handleMouseUp}
                                className={`border p-2 rounded-md text-sm font-medium transition-all duration-300 ${hour.disabled ? disabledStyle : selectedTimes.has(hour.time) ? selectedStyle : selectableStyle
                                    }`}
                                disabled={hour?.disabled}
                            >
                                {hour?.time}
                            </button>
                        ))}
                    </div>

                    <Row className="mt-4 text-center">
                        <Col className="text-lg font-medium" span={24}>
                            總時數：{totalHours} 小時
                        </Col>
                    </Row>
                </div>
            )}
        </>

    );
};

export { TimeSelector };
export { DeleteButton, PatchButton } from './../utility/componentOt/controllers/ProtableOtController'

const ExpandDiv = ({
    text,
    record
}) => {
    const Typography_P_maxLength = 10;
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpanded = () => {
        setIsExpanded(pre => !pre);
    }
    return <>
        <div>
            {isExpanded ? (
                <span>
                    {text} <CustomButton type={'link'} onClick={toggleExpanded} style={{ color: '#F29F58' }}>收起</CustomButton>
                </span>
            ) : (
                <span>
                    {text?.length > Typography_P_maxLength ? (
                        <>
                            {text.slice(0, Typography_P_maxLength)}... <CustomButton type={'link'} onClick={toggleExpanded} style={{ color: 'blue' }}> 展開</CustomButton>
                        </>
                    ) : (
                        text
                    )}
                </span>
            )}
        </div>
    </>
}
export { ExpandDiv };
const HeartOutlined = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        width="32"
        height="32"
        version="1.1"
        viewBox="0 0 128 128"
    >
        <path
            fill="#F44336"
            d="M92 8c15.324 0 27.813 12.375 27.996 27.656a12 12 0 0 0-.109 1.281l-.051 3.172c-2.652 24.742-37.203 60.523-55.84 77.273-18.5-16.617-52.695-52-55.773-76.742l-.109-3.703A12 12 0 0 0 8 35.656C8.188 20.375 20.676 8 36 8c8.422 0 16.352 3.875 21.754 10.625L64 26.43l6.246-7.805C75.648 11.875 83.578 8 92 8m0-8C80.621 0 70.598 5.383 64 13.625 57.402 5.383 47.379 0 36 0 16.117 0 0 16.117 0 36c0 .398.105.773.117 1.172H0C0 74.078 64 128 64 128s64-53.922 64-90.828h-.117c.012-.399.117-.774.117-1.172 0-19.883-16.117-36-36-36"
        ></path>
    </svg>
);
export { HeartOutlined };

const HeartFilled = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        width="32"
        height="32"
        version="1.1"
        viewBox="0 0 66.911 66.911"
    >
        <path
            fill="#E34326"
            d="M66.911 22.831c0-10.563-8.558-19.122-19.118-19.122-5.658 0-10.721 2.473-14.223 6.377l-.113.128c-3.5-3.98-8.618-6.505-14.334-6.505C8.561 3.709.005 12.268 0 22.831c0 5.834 2.629 11.059 6.758 14.565h-.007l27.104 25.806 26.308-25.806h-.012c4.128-3.506 6.76-8.727 6.76-14.565"
        ></path>
    </svg>
);
export { HeartFilled };

const ShareAltOutlined = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={fontSize}
        height={fontSize}
        viewBox="0 0 32 32"
        {...props}
    >
        <path
            fill={color}
            d="M5 5v22h22V5zm2 2h18v18H7zm13 3a2 2 0 0 0-1.992 2.156L13.32 14.5A2 2 0 0 0 12 14a2 2 0 0 0 0 4 2 2 0 0 0 1.32-.5l4.688 2.344A2 2 0 0 0 20 22a2 2 0 0 0 0-4 2 2 0 0 0-1.32.5l-4.688-2.344a2 2 0 0 0 0-.312L18.68 13.5A2 2 0 0 0 20 14a2 2 0 0 0 0-4"
        ></path>
    </svg>
);
export { ShareAltOutlined };

const ArrowRightOutlined = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <path
            fill="#5C5F62"
            d="m17.707 9.293-5-5a.999.999 0 1 0-1.414 1.414L14.586 9H3a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414"
        ></path>
    </svg>
);
export { ArrowRightOutlined };